/**
 * Angel Ashes — Ledger, draft persistence, summary chrome
 * Split from booking-wizard.js for Shopify Theme Editor's 256 KB asset limit.
 * Loaded before booking-wizard.js from sections/booking-wizard.liquid.
 */
(function (global) {
  'use strict'

  function create(deps) {
    deps = deps || {}
    var escapeHtml = deps.escapeHtml
    var formatMoney = deps.formatMoney
    var firstAvailableVariant = deps.firstAvailableVariant
    var sizedShopifyImageUrl = deps.sizedShopifyImageUrl || function (url, width) {
      if (typeof AngelAshesBookingMemorials !== 'undefined' && AngelAshesBookingMemorials.sizedShopifyImageUrl) {
        return AngelAshesBookingMemorials.sizedShopifyImageUrl(url, width)
      }
      return url || ''
    }
    var isLonsdaleTransport = deps.isLonsdaleTransport
    var isVetTransport = deps.isVetTransport
    var isPriorityCollectionSelected = deps.isPriorityCollectionSelected
    var collectionTimeframeForState = deps.collectionTimeframeForState
    var cremationProductForType = deps.cremationProductForType
    var ensureSharedCremationVariant = deps.ensureSharedCremationVariant
    var sharedCremationDisplayLabel = deps.sharedCremationDisplayLabel
    var suggestedVariant = deps.suggestedVariant
    var possessiveName = deps.possessiveName
    var isUsablePetName = deps.isUsablePetName
    var wrapGuidanceBarHtml = deps.wrapGuidanceBarHtml
    var stepCopyText = deps.stepCopyText
    var createInitialState = deps.createInitialState
    var computeSteps = deps.computeSteps
    var stepLabel = deps.stepLabel
    var stepSectionKey = deps.stepSectionKey
    var computeSectionProgress = deps.computeSectionProgress
    var findTransportCategory = deps.findTransportCategory
    var findTransportMainOption = deps.findTransportMainOption
    var requirementsForTransportState = deps.requirementsForTransportState
    var needsTransportCategoryStep = deps.needsTransportCategoryStep
    var getTransportCategories = deps.getTransportCategories
    var getReturnSpeedChoices = deps.getReturnSpeedChoices
    var getFilteredReturnSpeedChoices = deps.getFilteredReturnSpeedChoices
    var findReturnSpeedChoice = deps.findReturnSpeedChoice
    var applyReturnSpeedChoice = deps.applyReturnSpeedChoice
    var reconcileReturnSpeedSelection = deps.reconcileReturnSpeedSelection
    var getReturnMethodChoices = deps.getReturnMethodChoices
    var getFilteredReturnMethodChoices = deps.getFilteredReturnMethodChoices
    var findReturnMethodChoice = deps.findReturnMethodChoice
    var applyReturnMethodChoice = deps.applyReturnMethodChoice
    var reconcileReturnMethodSelection = deps.reconcileReturnMethodSelection
    var hasPurchasedMemorialItems = deps.hasPurchasedMemorialItems
    var mapReturnMethodDisplay = deps.mapReturnMethodDisplay
    var classifyReturnMethodKind = deps.classifyReturnMethodKind
    var hasReachedWizardStep = deps.hasReachedWizardStep
    var familyFacingTransportCategoryLabel = deps.familyFacingTransportCategoryLabel
    var lonsdaleServiceSummaryLabel = deps.lonsdaleServiceSummaryLabel
    var lonsdaleGoodbyeOptionLabel = deps.lonsdaleGoodbyeOptionLabel
    var mapLonsdaleGoodbyeDisplay = deps.mapLonsdaleGoodbyeDisplay
    var mapVetCollectionDisplay = deps.mapVetCollectionDisplay
    var mapHomeCollectionDisplay = deps.mapHomeCollectionDisplay
    var formatTransportTileParts = deps.formatTransportTileParts
    var compactTransportChoice = deps.compactTransportChoice
    var parseReturnSpeedLabel = deps.parseReturnSpeedLabel
    var formatPickupAddress = deps.formatPickupAddress
    var formatSummaryAddress = deps.formatSummaryAddress
    var formatAuDateDmy = deps.formatAuDateDmy
    var formatBookableDateLabel = deps.formatBookableDateLabel
    var formatCollectionDateShort = deps.formatCollectionDateShort
    var formatCollectionDateRange = deps.formatCollectionDateRange
    var formatSummaryDateLabel = deps.formatSummaryDateLabel
    var formatSummaryDateRange = deps.formatSummaryDateRange
    if (typeof formatAuDateDmy !== 'function') {
      formatAuDateDmy = function (ymd) {
        var parsed = typeof parseYmdLocal === 'function' ? parseYmdLocal(ymd) : null
        if (!parsed) return String(ymd || '')
        var dd = parsed.getDate()
        var mm = parsed.getMonth() + 1
        return (dd < 10 ? '0' : '') + dd + '-' + (mm < 10 ? '0' : '') + mm + '-' + parsed.getFullYear()
      }
    }
    var collectionEstimateRangeForState = deps.collectionEstimateRangeForState
    var collectionInCareEmailHelper = deps.collectionInCareEmailHelper
    var petFirstNameRef = deps.petFirstNameRef
    var bookingDateRules = deps.bookingDateRules
    var isBookingDateAllowed = deps.isBookingDateAllowed
    var bookingCalendarBounds = deps.bookingCalendarBounds
    var toYmd = deps.toYmd
    var parseYmdLocal = deps.parseYmdLocal
    var addDaysLocal = deps.addDaysLocal
    var addWorkingDaysLocal = deps.addWorkingDaysLocal
    var isHomeAddressInvalid = deps.isHomeAddressInvalid
    var timeWindowOptionsForState = deps.timeWindowOptionsForState
    var bookableArrivalTimeWindowsForState =
      deps.bookableArrivalTimeWindowsForState ||
      function (state, config) {
        return timeWindowOptionsForState(state, config) || []
      }
    var LONSDALE_FAMILY_LABEL = deps.LONSDALE_FAMILY_LABEL
    var getMemorialCatalog = deps.getMemorialCatalog
    var getMemorialEntry = deps.getMemorialEntry
    var urnAshSplitDisplayValue = deps.urnAshSplitDisplayValue
    var urnAshesPlacementDisplayValue = deps.urnAshesPlacementDisplayValue
    var urnAshDestinationDisplayValue = deps.urnAshDestinationDisplayValue
    var ashesPlacementSummaryLine = deps.ashesPlacementSummaryLine
    var ashesPlacementSummaryLines = deps.ashesPlacementSummaryLines
    var withAshesPlacementSummaryLine = deps.withAshesPlacementSummaryLine
    var memorialCategorySummaryLabel = deps.memorialCategorySummaryLabel
    var memorialPhotoSummaryDisplay = deps.memorialPhotoSummaryDisplay
    var effectivePhotoOrientation = deps.effectivePhotoOrientation
    var normalizePhotoPrintSize = deps.normalizePhotoPrintSize
    // LOCKED: buildLedger bare-calls this — must be a Cart.create dep (lives in MemorialUI).
    var normalizePhotoOrientation =
      deps.normalizePhotoOrientation ||
      (typeof AngelAshesBookingMemorialUI !== 'undefined' &&
        AngelAshesBookingMemorialUI.normalizePhotoOrientation) ||
      function (value) {
        var v = String(value || '').trim()
        if (v === 'landscape') return 'landscape'
        if (v === 'client_choice') return 'client_choice'
        return 'portrait'
      }
    var isMemorialMultiSelectMode = deps.isMemorialMultiSelectMode
    var isMemorialIncludedProductLine = deps.isMemorialIncludedProductLine
    var orderMemorialLinesForSummary = deps.orderMemorialLinesForSummary
    var nestMemorialLines = deps.nestMemorialLines
    var isMemorialAddonLineId = deps.isMemorialAddonLineId
    var memorialAddonParentLineId = deps.memorialAddonParentLineId
    var memorialAddonSourceForProduct = deps.memorialAddonSourceForProduct
    var firstMemorialAddonSource = deps.firstMemorialAddonSource
    var resolveMemorialAddonProductId = deps.resolveMemorialAddonProductId
    var parseMemorialAddonStepId = deps.parseMemorialAddonStepId
    var memorialAddonStepId = deps.memorialAddonStepId
    var focusMemorialAddonProduct = deps.focusMemorialAddonProduct
    var resolveMemorialItemAddonFlags = deps.resolveMemorialItemAddonFlags
    var resolvePhotoAddonVariant = deps.resolvePhotoAddonVariant
    // buildMemorialGalleryItems / isTangibleMemorialItem are defined below in this
    // create() — do NOT alias them from deps. A deps `var` would overwrite the
    // hoisted function declarations and export MemorialUI's copies, which close
    // over memorialReviewGroupLabel / isNoKeepsakeLabel that only exist here.
    var formatEngravingCombinedText = deps.formatEngravingCombinedText
    var sanitizeEngravingLine = deps.sanitizeEngravingLine
    var splitLegacyEngravingText = deps.splitLegacyEngravingText
    var normalizeEngravingExampleVisuals = deps.normalizeEngravingExampleVisuals
    var buildNameplateColourOptions = deps.buildNameplateColourOptions
    var ensureDefaultNameplateColour = deps.ensureDefaultNameplateColour
    var nameplatePreviewImageForOption = deps.nameplatePreviewImageForOption
    var nameplateSummaryLabelForAddon = deps.nameplateSummaryLabelForAddon
    var nameplateColourLabelFromFlags = deps.nameplateColourLabelFromFlags
    var resolveNameplateAddonVariant = deps.resolveNameplateAddonVariant
    var findNameplateVariantById = deps.findNameplateVariantById
    var normalizeNameplateFont = deps.normalizeNameplateFont
    var normalizeNameplateLines = deps.normalizeNameplateLines
    var NAMEPLATE_FONTS = deps.NAMEPLATE_FONTS
    var NAMEPLATE_BODY_FONT = deps.NAMEPLATE_BODY_FONT
    var NAMEPLATE_LINE1_MAX = deps.NAMEPLATE_LINE1_MAX || 14
    var NAMEPLATE_LINE2_MAX = deps.NAMEPLATE_LINE2_MAX || 26
    var sanitizeNameplateLine = deps.sanitizeNameplateLine || function (value, max) {
      var s = String(value == null ? '' : value).replace(/[\r\n\u2028\u2029]/g, '')
      if (max && s.length > max) s = s.slice(0, max)
      return s
    }
    var clampNameplateInscription = deps.clampNameplateInscription || function (nameplate) {
      if (!nameplate) return nameplate
      if (nameplate.text) nameplate.text = sanitizeNameplateLine(nameplate.text, NAMEPLATE_LINE1_MAX) || null
      if (nameplate.textLine2) {
        nameplate.textLine2 = sanitizeNameplateLine(nameplate.textLine2, NAMEPLATE_LINE2_MAX) || null
      }
      return nameplate
    }

  var BOOKING_DRAFT_KEY_LEGACY = 'angelAshesBookingDraft:v1'

  function bookingDraftStorageKey(config) {
    var flow = config && config.flow === 'shared' ? 'shared' : 'individual'
    return 'angelAshesBookingDraft:v2:' + flow
  }

  function variantIdOf(variant) {
    return variant && variant.id != null ? String(variant.id) : null
  }

  function findVariantById(product, variantId) {
    if (!product || !Array.isArray(product.variants) || variantId == null) return null
    return product.variants.find(function (v) {
      return v && String(v.id) === String(variantId) && v.available !== false
    }) || null
  }

  function serializeBookingDraft(state, config) {
    if (!state) return null
    var memorials = (typeof AngelAshesBookingMemorials !== 'undefined' && AngelAshesBookingMemorials.serializeMemorials)
      ? AngelAshesBookingMemorials.serializeMemorials(state)
      : {}
    return {
      v: 2,
      flow: config && config.flow,
      savedAt: Date.now(),
      currentStepId: state.currentStepId || 'pet',
      pet: {
        name: (state.pet && state.pet.name) || '',
        breed: (state.pet && state.pet.breed) || '',
        weightKg: state.pet && state.pet.weightKg != null ? state.pet.weightKg : null,
      },
      cremationType: state.cremationType || null,
      cremationVariantId: variantIdOf(state.cremationVariant),
      transport: {
        categoryId: state.transport.categoryId || null,
        categoryLabel: state.transport.categoryLabel || null,
        key: state.transport.key || null,
        label: state.transport.label || null,
        variantId: variantIdOf(state.transport.variant),
        subKey: state.transport.subKey || null,
        subLabel: state.transport.subLabel || null,
        subVariantId: variantIdOf(state.transport.subVariant),
        date: state.transport.date || null,
        calendarMonth: state.transport.calendarMonth || null,
        timeWindow: state.transport.timeWindow || null,
        vetClinic: state.transport.vetClinic || null,
        vetAddress: state.transport.vetAddress || null,
        vetClinicId: state.transport.vetClinicId || null,
        vetClinicEditing: !!state.transport.vetClinicEditing,
        vetClinicOutOfArea: !!state.transport.vetClinicOutOfArea,
        newAddress: state.transport.newAddress || '',
        newAddressLat: state.transport.newAddressLat,
        newAddressLng: state.transport.newAddressLng,
        addressOutOfArea: !!state.transport.addressOutOfArea,
        addressMissingStreetNumber: !!state.transport.addressMissingStreetNumber,
        addressEditing: !!state.transport.addressEditing,
      },
      memorials: memorials,
      returnSpeed: {
        key: state.returnSpeed.key || null,
        label: state.returnSpeed.label || null,
        variantId: variantIdOf(state.returnSpeed.variant),
      },
      returnMethod: {
        key: state.returnMethod.key || null,
        label: state.returnMethod.label || null,
        variantId: variantIdOf(state.returnMethod.variant),
        location: state.returnMethod.location || null,
        locationBlockId: state.returnMethod.locationBlockId || null,
      },
      specialInstructions: specialInstructionsStoredText(state),
      specialInstructionsOpen: specialInstructionsOpen(state),
      sharedAshesAcknowledged: !!state.sharedAshesAcknowledged,
    }
  }

  function clearBookingDraft(config) {
    try {
      if (config) {
        localStorage.removeItem(bookingDraftStorageKey(config))
      } else {
        localStorage.removeItem('angelAshesBookingDraft:v2:individual')
        localStorage.removeItem('angelAshesBookingDraft:v2:shared')
      }
      localStorage.removeItem(BOOKING_DRAFT_KEY_LEGACY)
    } catch (err) { /* ignore */ }
  }

  function saveBookingDraft(state, config) {
    try {
      var payload = serializeBookingDraft(state, config)
      if (!payload) return
      // Avoid writing empty first-load drafts
      var hasSignal =
        !!(payload.pet && (payload.pet.name || payload.pet.weightKg)) ||
        !!payload.cremationType ||
        !!(payload.transport && (payload.transport.categoryId || payload.transport.key)) ||
        !!(payload.returnSpeed && payload.returnSpeed.key) ||
        !!(payload.returnMethod && payload.returnMethod.key) ||
        Object.keys(payload.memorials || {}).length > 0
      if (!hasSignal && payload.currentStepId === 'pet') return
      var key = bookingDraftStorageKey(config)
      localStorage.setItem(key, JSON.stringify(payload))
      if (key !== BOOKING_DRAFT_KEY_LEGACY) {
        localStorage.removeItem(BOOKING_DRAFT_KEY_LEGACY)
      }
    } catch (err) { /* private mode / quota */ }
  }

  function readBookingDraftRaw(config) {
    try {
      var key = bookingDraftStorageKey(config)
      var raw = localStorage.getItem(key)
      if (!raw) {
        var legacy = localStorage.getItem(BOOKING_DRAFT_KEY_LEGACY)
        if (legacy) {
          var legacyData = JSON.parse(legacy)
          if (
            legacyData &&
            (legacyData.v === 1 || legacyData.v === 2) &&
            config &&
            config.flow &&
            legacyData.flow === config.flow
          ) {
            return legacyData
          }
        }
        return null
      }
      var data = JSON.parse(raw)
      if (!data || (data.v !== 1 && data.v !== 2)) return null
      return data
    } catch (err) {
      return null
    }
  }

  function restoreBookingDraft(state, config) {
    var data = readBookingDraftRaw(config)
    if (!data) return false
    if (data.flow && config.flow && data.flow !== config.flow) {
      clearBookingDraft(config)
      return false
    }

    try {
      if (data.pet) {
        state.pet.name = String(data.pet.name || '').trim()
        state.pet.breed = String(data.pet.breed || '').trim()
        var w = data.pet.weightKg
        state.pet.weightKg = w == null || w === '' || isNaN(Number(w)) ? null : Number(w)
      }

      if (data.cremationType === 'water' || data.cremationType === 'flame') {
        state.cremationType = data.cremationType
      } else if (config.flow === 'shared') {
        state.cremationType = null
      }

      var cremationProduct = cremationProductForType(config, state.cremationType) ||
        (config.flow === 'shared' ? config.products.shared : null)
      if (data.cremationVariantId && cremationProduct) {
        state.cremationVariant = findVariantById(cremationProduct, data.cremationVariantId)
      }
      if (!state.cremationVariant && cremationProduct) {
        if (config.flow === 'shared') {
          state.cremationVariant = firstAvailableVariant(cremationProduct)
        } else if (state.pet.weightKg) {
          state.cremationVariant = suggestedVariant(cremationProduct, state.pet.weightKg)
        }
      }
      if (config.flow !== 'shared' && cremationProduct && typeof suggestedVariant === 'function' && state.pet.weightKg) {
        var matchedBand = suggestedVariant(cremationProduct, state.pet.weightKg)
        if (matchedBand) state.cremationVariant = matchedBand
      }
      if (config.flow === 'shared' && typeof ensureSharedCremationVariant === 'function') {
        ensureSharedCremationVariant(state, config)
      }

      var t = data.transport || {}
      if (t.categoryId) {
        var cat = findTransportCategory(config, t.categoryId)
        if (cat) {
          state.transport.categoryId = cat.id
          state.transport.categoryLabel = cat.label
        }
      }

      if (t.key) {
        var mainOpt = findTransportMainOption(config, t.key)
        if (mainOpt) {
          state.transport.key = mainOpt.key
          state.transport.label = mainOpt.label
          state.transport.variant = mainOpt.variant || null
          if (!state.transport.categoryId && mainOpt.categoryId) {
            state.transport.categoryId = mainOpt.categoryId
            state.transport.categoryLabel = mainOpt.categoryLabel || null
          }
        }
      }

      // Restore address / clinic first so date rules can consider the path
      if (t.vetClinic && t.vetAddress && !t.vetClinicOutOfArea) {
        state.transport.vetClinic = t.vetClinic
        state.transport.vetAddress = t.vetAddress
        state.transport.vetClinicId = t.vetClinicId || null
        state.transport.vetClinicEditing = false
        state.transport.vetClinicOutOfArea = false
      }
      if (t.newAddress && !t.addressOutOfArea) {
        state.transport.newAddress = t.newAddress
        state.transport.newAddressLat = t.newAddressLat != null ? t.newAddressLat : null
        state.transport.newAddressLng = t.newAddressLng != null ? t.newAddressLng : null
        state.transport.addressOutOfArea = false
        state.transport.addressMissingStreetNumber = !!t.addressMissingStreetNumber
        state.transport.addressEditing = false
      }

      if (t.date && state.transport.key) {
        var rules = bookingDateRules(config, state)
        var bounds = bookingCalendarBounds(rules)
        if (
          t.date >= bounds.minYmd &&
          t.date <= bounds.maxYmd &&
          isBookingDateAllowed(t.date, rules)
        ) {
          state.transport.date = t.date
          state.transport.calendarMonth = t.calendarMonth || monthKeyFromDate(parseYmdLocal(t.date))
        }
      }

      if (t.timeWindow && state.transport.date) {
        var windows = bookableArrivalTimeWindowsForState(state, config) || []
        if (windows.indexOf(t.timeWindow) !== -1) {
          state.transport.timeWindow = t.timeWindow
        }
      }

      Object.keys(data.memorials || {}).forEach(function (gk) {
        if (gk === '__portraitOffer') {
          var po = data.memorials.__portraitOffer
          if (po && po.variantId) {
            state.portraitOffer = {
              productId: po.productId,
              variantId: po.variantId,
              label: po.label,
              price: po.price,
              image: po.image || null,
              photoUrl: po.photoUrl || null,
            }
          }
          return
        }
        var saved = data.memorials[gk]
        if (!saved) return
        var entry = getMemorialEntry(state, gk, saved.mode)
        entry.mode = saved.mode || entry.mode
        entry.skippedOptional = !!saved.skippedOptional
        entry.ashesPlacementMode =
          saved.ashesPlacementMode === 'divided' || saved.ashesPlacementMode === 'single_urn'
            ? saved.ashesPlacementMode
            : saved.ashSplit === 'yes'
              ? 'divided'
              : saved.ashSplit === 'no'
                ? 'single_urn'
                : null
        entry.ashSplit =
          entry.ashesPlacementMode === 'divided'
            ? 'yes'
            : entry.ashesPlacementMode === 'single_urn'
              ? 'no'
              : null
        entry.ashDestinationProductId =
          saved.ashDestinationProductId != null && String(saved.ashDestinationProductId) !== ''
            ? String(saved.ashDestinationProductId)
            : null
        entry.ashesReceivingProductIds = Array.isArray(saved.ashesReceivingProductIds)
          ? saved.ashesReceivingProductIds.map(String)
          : null
        entry.ashesPlacementUrnIds =
          saved.ashesPlacementUrnIds != null && String(saved.ashesPlacementUrnIds) !== ''
            ? String(saved.ashesPlacementUrnIds)
            : null
        entry.ashesKeepsakeProductIds = Array.isArray(saved.ashesKeepsakeProductIds)
          ? saved.ashesKeepsakeProductIds.map(String)
          : null
        entry.ashesRemainingKind = saved.ashesRemainingKind || null
        entry.ashesRemainingProductId =
          saved.ashesRemainingProductId != null && String(saved.ashesRemainingProductId) !== ''
            ? String(saved.ashesRemainingProductId)
            : null
        entry.ashesRemainingLabel = saved.ashesRemainingLabel || null
        entry._ashesPlacementError = null
        entry._ashesPlacementModalOpen = false
        entry._urnChangeOrAddPending = null
        if (Array.isArray(saved.items)) {
          entry.items = saved.items.map(function (it) {
            return {
              productId: it.productId,
              variantId: it.variantId,
              included: !!it.included,
              quantity: it.quantity || 1,
              properties: it.properties || {},
              label: it.label || 'Item',
              styleTitle: it.styleTitle || it.label || '',
              shopifyTitle: it.shopifyTitle || '',
              capacityRole: it.capacityRole || '',
              capacityKg: it.capacityKg != null ? it.capacityKg : null,
              weightMaxKg: it.weightMaxKg != null ? it.weightMaxKg : null,
              capacityLabel: it.capacityLabel || '',
              image: it.image || null,
              price: it.price,
              itemBlockId: it.itemBlockId || null,
              needsPhoto: !!it.needsPhoto,
              needsNameplate: !!it.needsNameplate,
              needsEngraving: !!it.needsEngraving,
              nameplateIncluded: !!it.nameplateIncluded,
            }
          })
        } else if (saved.itemId && saved.itemId !== '__none__') {
          // Legacy draft v1
          var blocks = config.memorialItemsByGroup[gk] || []
          var block = blocks.find(function (b) { return b.id === saved.itemId })
          if (block && block.settings && block.settings.product) {
            var product = block.settings.product
            var variant = saved.variantId ? findVariantById(product, saved.variantId) : firstAvailableVariant(product)
            entry.items = [{
              productId: product.id,
              variantId: variant ? variant.id : null,
              included: false,
              quantity: 1,
              properties: {},
              label: saved.itemLabel || product.title,
              image: product.image || null,
              price: variant ? variant.price : 0,
              itemBlockId: block.id,
              needsPhoto: !!block.settings.needs_photo,
              needsNameplate: !!block.settings.needs_nameplate,
              needsEngraving: !!block.settings.needs_engraving,
              nameplateIncluded: !!block.settings.nameplate_included && !!block.settings.needs_nameplate,
            }]
          }
        }
        function restoreMemorialAddonType(type, sa, productId) {
          if (!sa || !sa.choiceId) return
          var catalogRest = getMemorialCatalog(state, config)
          var source = memorialAddonSourceForProduct(
            state, config, gk, catalogRest, type, productId
          ) || firstMemorialAddonSource(state, config, gk, catalogRest, type)
          var feeProduct = null
          if (source && source.flags) {
            if (type === 'photo') feeProduct = source.flags.photoFeeProduct
            if (type === 'engraving') feeProduct = source.flags.engravingFeeProduct
          }
          var variant = null
          if (type === 'nameplate' && source && source.flags) {
            var npId = sa.variantId || (sa.choiceId && sa.choiceId !== 'no' ? sa.choiceId : null)
            var matched = npId ? findNameplateVariantById(source.flags, npId) : null
            variant = matched ? matched.variant : null
          } else if (type === 'photo' && resolvePhotoAddonVariant) {
            variant = resolvePhotoAddonVariant({
              choiceId: sa.choiceId,
              variantId: sa.variantId,
            }, source && source.flags)
          } else if (feeProduct) {
            if (sa.variantId) {
              variant = (feeProduct.variants || []).find(function (v) {
                return v && String(v.id) === String(sa.variantId)
              }) || null
            }
            if (!variant && typeof AngelAshesBookingMemorialUI !== 'undefined' &&
              AngelAshesBookingMemorialUI.firstPricedVariant) {
              variant = AngelAshesBookingMemorialUI.firstPricedVariant(feeProduct)
            }
            if (!variant) variant = firstAvailableVariant(feeProduct)
          }
          var targetPid = productId || (source && source.item && source.item.productId) || null
          focusMemorialAddonProduct(entry, targetPid)
          entry.addons[type] = {
            choiceId: sa.choiceId,
            choiceLabel: sa.choiceLabel || '',
            variant: variant,
            colour: type === 'nameplate'
              ? (sa.colour === 'gold' || sa.colour === 'silver'
                ? sa.colour
                : (sa.choiceId === 'gold' || sa.choiceId === 'silver' ? sa.choiceId : null))
              : undefined,
            photoUrl: type === 'photo' ? (sa.photoUrl || null) : null,
            photoPrintUrl: type === 'photo' ? (sa.photoPrintUrl || null) : null,
            size: type === 'photo' ? normalizePhotoPrintSize(sa.size) : null,
            orientation: type === 'photo'
              ? (String(sa.orientation || '').trim() === 'landscape' ? 'landscape'
                : String(sa.orientation || '').trim() === 'portrait' ? 'portrait'
                : null)
              : null,
            _orientationTouched: type === 'photo'
              ? !!(sa._orientationTouched || sa.orientation)
              : undefined,
            text: (type === 'engraving' || type === 'nameplate') ? (sa.text || null) : null,
            textLine2: (type === 'engraving' || type === 'nameplate') ? (sa.textLine2 || null) : null,
            secondLineMode: (type === 'nameplate' || type === 'engraving')
              ? (sa.secondLineMode === 'custom' || sa.secondLineMode === 'suggestion'
                ? sa.secondLineMode
                : null)
              : null,
            lines: (type === 'nameplate' || type === 'engraving')
              ? (sa.lines === 2 ? 2 : (sa.lines === 1 ? 1 : null))
              : null,
            _linesTouched: (type === 'nameplate' || type === 'engraving')
              ? !!sa._linesTouched
              : undefined,
            _line2Touched: (type === 'nameplate' || type === 'engraving')
              ? !!(sa._line2Touched || (
                String(sa.textLine2 || '').trim() &&
                sa.choiceId &&
                String(sa.choiceId) !== 'no'
              ))
              : undefined,
            font: type === 'nameplate' ? (sa.font || null) : null,
            _fontTouched: type === 'nameplate'
              ? !!(sa._fontTouched || (sa.font && normalizeNameplateFont(sa.font) !== NAMEPLATE_FONTS[0].id))
              : undefined,
          }
          if (type === 'nameplate') {
            clampNameplateInscription(entry.addons.nameplate)
          }
          if (type === 'engraving') {
            var eng = entry.addons.engraving
            if (eng && eng.text && !eng.textLine2 && String(eng.text).indexOf('\n') !== -1) {
              var splitEng = splitLegacyEngravingText(eng.text)
              eng.text = splitEng.line1 || null
              eng.textLine2 = splitEng.line2 || null
            } else if (eng) {
              if (eng.text) eng.text = sanitizeEngravingLine(eng.text, ENGRAVING_LINE1_MAX)
              if (eng.textLine2) eng.textLine2 = sanitizeEngravingLine(eng.textLine2, ENGRAVING_LINE2_MAX)
            }
            if (eng) {
              // Legacy drafts without lines default to Two (nameplate conversion open-state).
              if (eng.lines !== 1 && eng.lines !== 2) eng.lines = 2
              // Hand engraving has no font picker — drop any legacy draft font.
              eng.font = null
              eng._fontTouched = undefined
              if (normalizeNameplateLines(eng.lines) === 1) {
                eng.textLine2 = null
                eng.secondLineMode = null
              }
            }
          }
        }

        var savedItemAddons = saved.itemAddons && typeof saved.itemAddons === 'object'
          ? saved.itemAddons
          : null
        if (savedItemAddons && Object.keys(savedItemAddons).length) {
          Object.keys(savedItemAddons).forEach(function (pid) {
            var bucket = savedItemAddons[pid] || {}
            Object.keys(bucket).forEach(function (type) {
              restoreMemorialAddonType(type, bucket[type], pid)
            })
          })
        } else {
          Object.keys(saved.addons || {}).forEach(function (type) {
            restoreMemorialAddonType(type, saved.addons[type], null)
          })
        }
      })
      var restoredCatalog = getMemorialCatalog(state, config)
      if (typeof AngelAshesBookingMemorials !== 'undefined' && AngelAshesBookingMemorials.validateSelections) {
        if (AngelAshesBookingMemorials.validateSelections(restoredCatalog, state)) {
          state.memorialUnavailableNotice = true
        }
      }
      // Align ashes placement with restored urn set (never preselect when unset).
      if (typeof AngelAshesBookingMemorials !== 'undefined' && AngelAshesBookingMemorials.syncAshesPlacement) {
        var urnEntry = state.memorials && state.memorials.urn
        if (urnEntry) AngelAshesBookingMemorials.syncAshesPlacement(urnEntry)
      } else {
        urnAshesPlacementDisplayValue(state)
        urnAshDestinationDisplayValue(state)
      }

      if (data.returnSpeed && data.returnSpeed.key) {
        var rs = findReturnSpeedChoice(config, data.returnSpeed.key, state.cremationType, state)
        if (rs) applyReturnSpeedChoice(state, rs)
      }
      if (
        data.returnMethod &&
        data.returnMethod.key &&
        (config.flow !== 'shared' || hasPurchasedMemorialItems(state, config))
      ) {
        var rm = findReturnMethodChoice(config, data.returnMethod.key)
        if (rm) {
          applyReturnMethodChoice(state, rm)
          if (data.returnMethod.location) state.returnMethod.location = data.returnMethod.location
          if (data.returnMethod.locationBlockId) {
            state.returnMethod.locationBlockId = data.returnMethod.locationBlockId
          }
        }
      }

      if (data.specialInstructions != null) {
        state.specialInstructions = specialInstructionsStoredText({
          specialInstructions: data.specialInstructions,
        })
      }
      // Always land collapsed. Note text is restored above; do not reopen
      // a persisted accordion (previous sessions saved `true` after typing).
      state.specialInstructionsOpen = false
      if (data.sharedAshesAcknowledged === true || data.sharedAshesAcknowledged === false) {
        state.sharedAshesAcknowledged = data.sharedAshesAcknowledged
      } else {
        state.sharedAshesAcknowledged = false
      }
      state.sharedAshesAckInvalid = false

      // Land on a still-valid step; prefer saved step when present in sequence
      var steps = computeSteps(state, config)
      var wanted = data.currentStepId || 'pet'
      var found = steps.some(function (s) { return s.id === wanted })
      // Legacy drafts used category-scoped addon ids (`…:addon:photo` without productId).
      if (!found && String(wanted).indexOf(':addon:') !== -1) {
        var legacyParsed = parseMemorialAddonStepId(wanted)
        if (legacyParsed && !legacyParsed.productId) {
          var remapped = steps.find(function (s) {
            return s.groupKey === legacyParsed.groupKey && s.addonType === legacyParsed.type
          })
          if (remapped) {
            wanted = remapped.id
            found = true
          }
        }
      }
      state.currentStepId = found ? wanted : (steps[0] && steps[0].id) || 'pet'
      return true
    } catch (err) {
      console.warn('Booking wizard: draft restore failed', err)
      clearBookingDraft(config)
      return false
    }
  }

  function petProperties(state) {
    var props = { 'Pet Name': state.pet.name || '' }
    if (state.pet.breed) props['Breed'] = state.pet.breed
    if (state.pet.weightKg) props['Weight (kg)'] = String(state.pet.weightKg)
    return props
  }

  /**
   * Shopify hides line properties that start with `_` from checkout. Ops still
   * receives them on the order; MemorialBridge strips the prefix when reading.
   * Private names cannot contain spaces (`_Photo_URL`, not `_Photo URL`) —
   * cart/add.js returns 422 otherwise.
   */
  function opsHiddenCartKey(name) {
    var n = String(name || '').trim().replace(/\s+/g, '_')
    if (!n) return n
    return n.charAt(0) === '_' ? n : '_' + n
  }

  /** Visible keys stay as-is; hidden / already-`_` keys must not contain spaces. */
  function cartLinePropertyKey(name, hidden) {
    var raw = String(name || '').trim()
    if (!raw) return raw
    if (hidden) return opsHiddenCartKey(raw)
    if (raw.charAt(0) === '_') return opsHiddenCartKey(raw.replace(/^_+/, ''))
    return raw
  }

  var CART_LINE_PROPERTY_VALUE_MAX = 255

  function compactCartImageUrl(url) {
    var src = String(url || '').trim()
    var origin = ''
    if (!src) return ''
    if (/^(data:|blob:)/i.test(src)) return ''
    if (src.indexOf('//') === 0) src = 'https:' + src
    else if (src.charAt(0) === '/') {
      try {
        origin = String((typeof location !== 'undefined' && location && location.origin) || '')
      } catch (eOrigin) {
        origin = ''
      }
      if (!origin) origin = 'https://angelashes.com.au'
      src = origin + src
    }
    if (!/^https?:\/\//i.test(src)) return ''
    if (
      typeof AngelAshesBookingMemorials !== 'undefined' &&
      AngelAshesBookingMemorials.sizedShopifyImageUrl
    ) {
      src = AngelAshesBookingMemorials.sizedShopifyImageUrl(src, 480)
    }
    if (src.length <= CART_LINE_PROPERTY_VALUE_MAX) return src
    var bare = src.split('?')[0]
    if (bare.length <= CART_LINE_PROPERTY_VALUE_MAX && /^https?:\/\//i.test(bare)) return bare
    return ''
  }

  function normalizeCartLineProperties(props) {
    if (!props || typeof props !== 'object') return {}
    var out = {}
    Object.keys(props).forEach(function (key) {
      var val = props[key]
      if (val == null) return
      var str = String(val).trim()
      if (!str) return
      var safeKey = cartLinePropertyKey(key, false)
      if (!safeKey) return
      if (str.length > CART_LINE_PROPERTY_VALUE_MAX) {
        str = str.slice(0, CART_LINE_PROPERTY_VALUE_MAX)
      }
      out[safeKey] = str
    })
    return out
  }

  function assignCartProperties(target, source, hidden) {
    if (!target || !source) return target
    Object.keys(source).forEach(function (key) {
      var val = source[key]
      if (val == null) return
      var str = String(val).trim()
      if (!str) return
      if (str.length > CART_LINE_PROPERTY_VALUE_MAX) {
        str = str.slice(0, CART_LINE_PROPERTY_VALUE_MAX)
      }
      target[cartLinePropertyKey(key, hidden)] = str
    })
    return target
  }

  function cremationGroupLabel(config) {
    return config.flow === 'shared' ? 'Shared cremation' : 'Individual cremation'
  }

  function bookingRailTitle(config) {
    var heading = (config.heading || '').trim()
    if (heading) {
      // Strip leading “Book a/an ” so the rail can read “Individual cremation…”
      heading = heading.replace(/^book\s+an?\s+/i, '')
    }
    if (!heading) heading = config.flow === 'shared' ? 'Shared cremation' : 'Individual cremation'
    return heading
  }

  function sentenceCase(value) {
    var s = String(value || '').trim()
    if (!s) return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

  /**
   * Shopify line property / note-attribute key for the booked day.
   * Bring-to-Lonsdale is not a home collection — use "Date". Home / vet pickup keep
   * "Collection Date" so checkout copy still matches collection flows.
   * @see BOOKING_DEFAULT_DRIVER_FIELDS in lib/booking-shopify-cart-contract.ts
   */
  function transportDatePropertyKey(state) {
    if (isLonsdaleTransport(state)) return 'Date'
    return 'Collection Date'
  }

  function transportNoteLabel(state) {
    // Prefer category + subtype so ops can parse Collection Type (LONSDALE / VET / HOME).
    // Category uses family-facing copy (“Bring to Lonsdale”); LONSDALE still classifies.
    // The Goodbye Room variant already shows “Short Goodbye (5 min)”, so Collection
    // Type stays the place only and does not repeat the option.
    var parts = []
    var categoryPart = familyFacingTransportCategoryLabel(state) || state.transport.categoryLabel
    if (typeof isLonsdaleTransport === 'function' && isLonsdaleTransport(state)) {
      return categoryPart || 'Bring to Lonsdale'
    }
    var servicePart = state.transport.label
    if (categoryPart) {
      parts.push(categoryPart)
      if (servicePart && servicePart !== state.transport.categoryLabel && servicePart !== categoryPart) {
        parts.push(servicePart)
      }
    } else if (servicePart) {
      parts.push(servicePart)
    }
    if (state.transport.subLabel) parts.push(state.transport.subLabel)
    return parts.filter(Boolean).join(' · ')
  }

  function transportCategoryShort(state) {
    var map = { lonsdale: 'Lonsdale', vet: 'Vet', home: 'Home' }
    if (state.transport.categoryId && map[state.transport.categoryId]) {
      return map[state.transport.categoryId]
    }
    var label = String(state.transport.categoryLabel || '')
      .replace(/\s*Handover\s*\/\s*/i, ' ')
      .replace(/\s*\/\s*Drop\s*Off/i, '')
      .replace(/\s*Drop\s*Off/i, '')
      .replace(/\s*Collection\b/i, '')
      .replace(/\s+/g, ' ')
      .trim()
    return label || state.transport.categoryLabel || null
  }

  function compactServiceLevel(text) {
    var raw = String(text || '').replace(/\([^)]*\)/g, '').replace(/^~\s*/, '').replace(/\s+/g, ' ').trim()
    if (/after\s*hours?/i.test(raw) || /same[\s-]*day/i.test(raw) || /public\s*holiday/i.test(raw)) return 'After Hours'
    if (/^standard\b/i.test(raw)) return 'Standard'
    var s = raw
      .replace(/\bwithin\s+/i, '')
      .replace(/\bhours?\b/gi, 'hrs')
      .replace(/\bminutes?\b/gi, 'min')
      .replace(/\s+/g, ' ')
      .trim()
    // “48 hrs” reads cleaner than “48 hrs (Mon–Fri)” after day stripping
    if (/^\d+\s*hrs$/i.test(s)) return s
    return s
  }

  /** Quiet Care Arrangements rail: “Home · Standard Collection” → “Home · Standard”. */
  function compactCareArrangementsServiceLabel(label) {
    return String(label || '')
      .replace(/\bAfter Hours and Public Holiday Collection\b/gi, 'After Hours')
      .replace(/\bSame[\s-]*Day Collection\b/gi, 'After Hours')
      .replace(/\bPriority Collection\b/gi, 'Priority')
      .replace(/\bRegional Collection\b/gi, 'Regional')
      .replace(/\bStandard Collection\b/gi, 'Standard')
      .replace(/\s+Collection\b/g, '')
      .replace(/\s+/g, ' ')
      .trim()
  }

  /**
   * Customer-facing Vet Collection tile copy (service type first, location as subtitle).
   * Shopify variant titles may still say “Adelaide · Weekdays…” — cart / ops keep those.
   * Returns { title, desc } or null when the label is not a known vet service level.
   * Multi-line desc uses \n; .baw-tile-desc has white-space: pre-line.
   * After Hours is home-only — never mapped for Vet tiles/sidebar.
   *
   * Old → display:
   *   Adelaide · Weekdays / Standard…     → Standard Collection  · Metro Adelaide / Collected within 7 days
   *   Adelaide · 48 hour / Priority…      → Priority Collection  · Metro Adelaide / Collected within 2 working days
   *   South East / Regional…              → Regional Collection  · South East SA / Collected within 7 days
   */

  function transportSummaryLabel(state) {
    if (isLonsdaleTransport(state)) {
      var arrivalCat = familyFacingTransportCategoryLabel(state) || LONSDALE_FAMILY_LABEL
      var arrivalDetail = lonsdaleServiceSummaryLabel(state)
      if (state.transport.subLabel) {
        var arrivalSub = compactTransportChoice(state.transport.subLabel)
        if (
          arrivalSub &&
          arrivalSub !== arrivalDetail &&
          !/goodbye/i.test(arrivalSub) &&
          !/^\d+\s*min$/i.test(arrivalSub)
        ) {
          arrivalDetail = arrivalDetail ? arrivalDetail + ' · ' + arrivalSub : arrivalSub
        }
      }
      if (arrivalCat && arrivalDetail && arrivalDetail !== arrivalCat) {
        return arrivalCat + ' · ' + arrivalDetail
      }
      return arrivalCat || arrivalDetail || state.transport.label || ''
    }
    var cat = transportCategoryShort(state)
    var collectionOpts = {
      forceVet: state.transport.categoryId === 'vet',
      forceHome: state.transport.categoryId === 'home',
    }
    var detail = null
    if (state.transport.label && state.transport.label !== state.transport.categoryLabel) {
      detail = compactTransportChoice(state.transport.label, collectionOpts)
    }
    if (state.transport.subLabel) {
      var subBit = compactTransportChoice(state.transport.subLabel, collectionOpts)
      detail = detail ? detail + ' · ' + subBit : subBit
    }
    if (cat && detail && detail !== cat) return cat + ' · ' + detail
    return cat || detail || state.transport.label || ''
  }

  function buildLedger(state, config) {
    var items = []

    if (state.pet.name) {
      var petMeta = []
      if (state.pet.breed) petMeta.push(state.pet.breed)
      if (state.pet.weightKg) petMeta.push(String(state.pet.weightKg).replace(/\.0$/, '') + ' kg')
      items.push({
        id: 'pet',
        editStepId: 'pet',
        groupLabel: 'For',
        valueLabel: state.pet.name + (petMeta.length ? ' · ' + petMeta.join(' · ') : ''),
        petName: state.pet.name,
        petMeta: petMeta.join(' · '),
        isPetHeader: true,
        price: 0,
      })
    }

    var cremationParentId = null
    if (state.cremationVariant) {
      cremationParentId = 'cremation'
      var cremationLabel = config.flow === 'shared'
        ? (typeof sharedCremationDisplayLabel === 'function'
          ? sharedCremationDisplayLabel(config, state.cremationVariant)
          : 'Shared cremation')
        : (state.cremationType === 'water' ? 'Water · ' : state.cremationType === 'flame' ? 'Flame · ' : '') + state.cremationVariant.title
      var sharedSublabel = config.flow === 'shared' && config.cremationCards && config.cremationCards.shared
        ? String(config.cremationCards.shared.sublabel || '').trim()
        : ''
      items.push({
        id: 'cremation',
        editStepId: config.flow === 'individual' ? 'cremation-type' : 'pet',
        groupLabel: cremationGroupLabel(config),
        valueLabel: cremationLabel + (sharedSublabel ? ' · ' + sharedSublabel : ''),
        price: Number(state.cremationVariant.price) || 0,
        variantId: state.cremationVariant.id,
        properties: petProperties(state),
      })
    }

    if (state.transport.key || state.transport.categoryId) {
      var transportEdit = needsTransportCategoryStep(config) ? 'transport-category' : 'transport-main'
      var transportLabel = transportNoteLabel(state) || state.transport.label
      var transportDisplay = transportSummaryLabel(state) || transportLabel
      var transportGroup = isLonsdaleTransport(state) ? 'Arrival' : 'Care arrangements'
      items.push({
        id: 'transport-main', editStepId: transportEdit, groupLabel: transportGroup,
        valueLabel: transportDisplay,
        price: state.transport.variant ? Number(state.transport.variant.price) || 0 : 0,
        // Always add as its own cart line (shows FREE when $0) so the SKU is clear at checkout.
        // Skip sold-out $0 arrival SKUs — posting them 422s the whole booking.
        variantId: sellableVariantId(state.transport.variant),
        nestedUnder: cremationParentId,
        properties: transportLabel
          ? assignCartProperties({}, { 'Collection Type': transportLabel }, false)
          : undefined,
      })
    }
    if (state.transport.subKey) {
      items.push({
        id: 'transport-sub', editStepId: 'transport-sub',
        groupLabel: isLonsdaleTransport(state) ? 'Arrival' : 'Care arrangements',
        valueLabel: state.transport.subLabel,
        price: state.transport.subVariant ? Number(state.transport.subVariant.price) || 0 : 0,
        variantId: sellableVariantId(state.transport.subVariant),
        nestedUnder: cremationParentId,
      })
    }
    var td = state.transport
    var transportReq = requirementsForTransportState(state, config)
    // Date / time / clinic / address belong on the transport SKU, not cremation.
    // Also mirror date/time onto cremation so ops import still gets a schedule when
    // nested transport children drop attach-only props at checkout.
    var transportDetailsTarget = state.transport.subKey ? 'transport-sub' : 'transport-main'
    var transportDetailAlsoAttach = cremationParentId || null
    if (td.date) {
      var dateProp = {}
      dateProp[transportDatePropertyKey(state)] = formatAuDateDmy(td.date)
      items.push({
        id: 'transport-date', editStepId: 'transport-details',
        groupLabel: transportReq.dateLabel || 'Pickup date',
        valueLabel: formatBookableDateLabel(td.date) || td.date,
        price: 0,
        attachPropertiesToLineId: transportDetailsTarget,
        attachPropertiesAlsoToLineId: transportDetailAlsoAttach,
        properties: dateProp,
      })
    }
    if (td.timeWindow) {
      items.push({
        id: 'transport-time', editStepId: 'transport-details',
        groupLabel: transportReq.timeWindowLabel || 'Preferred time',
        valueLabel: td.timeWindow,
        price: 0,
        attachPropertiesToLineId: transportDetailsTarget,
        attachPropertiesAlsoToLineId: transportDetailAlsoAttach,
        properties: { 'Preferred Time Window': td.timeWindow },
      })
    }
    if (td.vetClinic && td.vetAddress && !td.vetClinicEditing && !td.vetClinicOutOfArea) {
      var vetProps = {}
      assignCartProperties(vetProps, { 'Vet Clinic': td.vetClinic }, false)
      assignCartProperties(vetProps, { 'Vet Address': formatPickupAddress(td.vetAddress) }, true)
      items.push({
        id: 'transport-vet', editStepId: 'transport-details',
        groupLabel: 'Vet clinic',
        valueLabel: td.vetClinic,
        price: 0,
        attachPropertiesToLineId: transportDetailsTarget,
        properties: vetProps,
      })
    }
    if (td.newAddress && !td.addressEditing && !isHomeAddressInvalid(td)) {
      var addressValue = formatPickupAddress(td.newAddress)
      items.push({
        id: 'transport-address', editStepId: 'transport-details', groupLabel: 'Pickup address',
        valueLabel: addressValue,
        price: 0,
        attachPropertiesToLineId: transportDetailsTarget,
        properties: {
          'Pickup Address': addressValue,
        },
      })
    }

    ;(function pushMemorialLedger() {
      var catalog = getMemorialCatalog(state, config)
      catalog.categories.forEach(function (cat) {
        var entry = getMemorialEntry(state, cat.key, cat.selectionMode)
        // buildLedger walks every vessel and retargets entry.addons. Restore the
        // step's focused product afterward — otherwise photo/nameplate/engraving
        // click handlers that write entry.addons.* hit the last urn's bucket and
        // the active step re-render looks like "cards do nothing" (multi-select).
        var priorFocus =
          entry && entry._focusedAddonProductId != null && String(entry._focusedAddonProductId) !== ''
            ? String(entry._focusedAddonProductId)
            : null
        var categorySummaryLabel = memorialCategorySummaryLabel(cat, state)
        if (
          typeof AngelAshesBookingMemorials !== 'undefined' &&
          AngelAshesBookingMemorials.bindPlacementWeight
        ) {
          AngelAshesBookingMemorials.bindPlacementWeight(entry, state)
        }
        var multiUrnNumbered =
          cat.key === 'urn' &&
          isMemorialMultiSelectMode(cat.selectionMode) &&
          (typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.fullCapacityVesselCount
            ? AngelAshesBookingMemorials.fullCapacityVesselCount(entry) >= 2
            : (entry.items || []).length >= 2)
        var ashesReceiverCount = 0
        if (
          multiUrnNumbered &&
          typeof AngelAshesBookingMemorials !== 'undefined' &&
          AngelAshesBookingMemorials.urnAshesTagForProduct
        ) {
          ;(entry.items || []).forEach(function (countIt) {
            if (
              AngelAshesBookingMemorials.urnAshesTagForProduct(entry, countIt.productId) === 'Ashes'
            ) {
              ashesReceiverCount++
            }
          })
        }
        ;(entry.items || []).forEach(function (it, idx) {
          var lineId = 'memorial:' + cat.key + ':' + idx
          var props = {}
          assignCartProperties(props, it.properties || {}, false)
          var ashesTag = null
          if (
            multiUrnNumbered &&
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.urnAshesTagForProduct
          ) {
            ashesTag = AngelAshesBookingMemorials.urnAshesTagForProduct(entry, it.productId)
          }
          var displayCard = null
          if (typeof AngelAshesBookingMemorials !== 'undefined') {
            if (AngelAshesBookingMemorials.findDisplayCardInCategory) {
              displayCard = AngelAshesBookingMemorials.findDisplayCardInCategory(cat, it.productId)
            } else if (AngelAshesBookingMemorials.findCardInCategory) {
              displayCard = AngelAshesBookingMemorials.findCardInCategory(cat, it.productId)
            }
          }
          var colourLabel = String(it.variantMeta || '').trim()
          if (!colourLabel && displayCard && displayCard.variantMeta) {
            colourLabel = String(displayCard.variantMeta).trim()
          }
          if (
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.isWeightSizeVariantMeta &&
            AngelAshesBookingMemorials.isWeightSizeVariantMeta(colourLabel)
          ) {
            colourLabel = ''
          } else if (
            displayCard &&
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.productHasWeightSizingVariants &&
            AngelAshesBookingMemorials.productHasWeightSizingVariants(displayCard)
          ) {
            colourLabel = ''
          }
          var qty = memorialOrderQuantity(it)
          var unitPrice = it.included ? 0 : (Number(it.price) || 0)
          var productImage = it.image || null
          if (
            displayCard &&
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.resolveCardImage
          ) {
            productImage =
              AngelAshesBookingMemorials.resolveCardImage(
                displayCard,
                displayCard.activeOptionId || it.variantId
              ) ||
              displayCard.image ||
              productImage
          } else if (displayCard && displayCard.image) {
            productImage = displayCard.image
          }
          var npMetal = null
          if (
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.nameplateMetalForProduct
          ) {
            npMetal = AngelAshesBookingMemorials.nameplateMetalForProduct(entry, it.productId)
          }
          var titleHay = String(
            (displayCard && displayCard.title) || it.styleTitle || it.label || ''
          ).toLowerCase()
          var isPhotoStyleProduct = !!(
            (displayCard && displayCard.needsPhoto) ||
            it.needsPhoto ||
            /\bphoto\b/.test(titleHay)
          )
          // Photo products keep the merchandising Card photo on the rail
          // (same as the grid). Dual-window personalise artboards are
          // photo-step mockups only — a 36px crop shows the paw pane.
          var metalForCard = npMetal
          var metalCardSrc = null
          if (
            metalForCard &&
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.resolveMetalCardImage
          ) {
            metalCardSrc = AngelAshesBookingMemorials.resolveMetalCardImage({
              card_image:
                (displayCard && displayCard._variantCutoffSettings && displayCard._variantCutoffSettings.card_image) ||
                (displayCard && displayCard.baseImage) ||
                (displayCard && displayCard.image) ||
                it.image ||
                null,
              card_image_gold:
                (displayCard && displayCard.cardImageGold) ||
                it.cardImageGold ||
                null,
              card_image_silver:
                (displayCard && displayCard.cardImageSilver) ||
                it.cardImageSilver ||
                null,
              personalise_image:
                it.personaliseImage ||
                (displayCard && displayCard.personaliseImage) ||
                null,
              personalise_image_gold:
                it.personaliseImageGold ||
                (displayCard && displayCard.personaliseImageGold) ||
                null,
              personalise_image_silver:
                it.personaliseImageSilver ||
                (displayCard && displayCard.personaliseImageSilver) ||
                null,
            }, metalForCard)
          }
          if (metalCardSrc) {
            var cartImg = compactCartImageUrl(metalCardSrc)
            if (cartImg) assignCartProperties(props, { 'Cart Image': cartImg }, true)
          }
          if (multiUrnNumbered && countsAsFullUrn) {
            var urnSlotIndex = idx + 1
            if (urnSlotIndex >= 1 && urnSlotIndex <= 26) {
              assignCartProperties(
                props,
                { 'Urn slot': String.fromCharCode(64 + urnSlotIndex) },
                false
              )
            }
          }
          if (ashesTag) {
            assignCartProperties(props, { 'Ashes': ashesTag }, false)
            if (ashesTag === 'Ashes' && ashesReceiverCount > 0) {
              var ashesPct =
                ashesReceiverCount === 1 ? 100 : Math.round(100 / ashesReceiverCount)
              assignCartProperties(props, { 'Ashes %': ashesPct + '%' }, false)
            } else if (ashesTag === 'Empty') {
              assignCartProperties(props, { 'Ashes %': '0%' }, false)
            }
          }
          var memorialVariantId = it.included && !it.variantId ? null : it.variantId
          if (
            npMetal &&
            memorialVariantId &&
            displayCard &&
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.variantIdForNameplateMetal
          ) {
            memorialVariantId = AngelAshesBookingMemorials.variantIdForNameplateMetal(
              displayCard,
              npMetal,
              memorialVariantId
            )
          }
          var personaliseSrc = null
          var isUrnGroup = String(cat.key || '') === 'urn'
          if (
            !isUrnGroup &&
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.resolvePersonaliseStepImage
          ) {
            personaliseSrc = AngelAshesBookingMemorials.resolvePersonaliseStepImage({
              personaliseImage: it.personaliseImage || (displayCard && displayCard.personaliseImage) || null,
              personaliseImageGold:
                it.personaliseImageGold || (displayCard && displayCard.personaliseImageGold) || null,
              personaliseImageSilver:
                it.personaliseImageSilver || (displayCard && displayCard.personaliseImageSilver) || null,
            }, npMetal || metalForCard)
          }
          // Ink Frame Set and other non-photo plates keep Card photo on
          // review + rail. Photo products also keep the Card photo on the
          // rail until a client photo exists (then the generated mockup).
          var usedPersonalise = !!personaliseSrc && isPhotoStyleProduct
          var summaryImage = metalCardSrc || productImage
          if (!summaryImage && usedPersonalise) {
            summaryImage = personaliseSrc
          }
          var capacityRole =
            (displayCard && displayCard.capacityRole) || it.capacityRole || ''
          var capacityKg =
            displayCard && displayCard.capacityKg != null
              ? displayCard.capacityKg
              : it.capacityKg != null
                ? it.capacityKg
                : null
          var weightKg =
            state && state.pet && state.pet.weightKg != null ? Number(state.pet.weightKg) : null
          var weightMaxKg =
            displayCard && displayCard.weightMaxKg != null
              ? displayCard.weightMaxKg
              : it.weightMaxKg != null
                ? it.weightMaxKg
                : null
          var countsAsFullUrn =
            typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.isFullCapacityItem
              ? AngelAshesBookingMemorials.isFullCapacityItem(
                  {
                    capacityRole: capacityRole,
                    capacityKg: capacityKg,
                    weightMaxKg: weightMaxKg,
                  },
                  weightKg
                )
              : capacityRole !== 'keepsake' ||
                (typeof AngelAshesBookingMemorials !== 'undefined' &&
                  AngelAshesBookingMemorials.keepsakeActsAsFullCapacity &&
                  AngelAshesBookingMemorials.keepsakeActsAsFullCapacity(
                    { capacityRole: capacityRole, capacityKg: capacityKg },
                    weightKg
                  ))
          items.push({
            id: lineId,
            editStepId: cat.editStepId,
            groupLabel: categorySummaryLabel || cat.reviewLabel || cat.title,
            memorialGroupKey: cat.key,
            memorialCategoryLabel: categorySummaryLabel,
            productId: it.productId != null ? it.productId : null,
            valueLabel:
              (displayCard && displayCard.title) ||
              it.styleTitle ||
              it.label,
            image: summaryImage,
            personaliseThumb: !!(usedPersonalise && summaryImage && summaryImage === personaliseSrc),
            reviewBlankCardImage:
              (displayCard && displayCard.reviewBlankCardImage) ||
              it.reviewBlankCardImage ||
              null,
            personaliseImage:
              it.personaliseImage ||
              (displayCard && displayCard.personaliseImage) ||
              null,
            needsPhoto: !!(
              (displayCard && displayCard.needsPhoto) ||
              it.needsPhoto
            ),
            price: unitPrice * qty,
            quantity: qty,
            variantId: memorialVariantId,
            included: !!it.included,
            properties: props,
            selectionIndex: multiUrnNumbered && countsAsFullUrn ? idx + 1 : null,
            ashesTag: ashesTag,
            variantMeta: colourLabel,
            capacityRole: capacityRole,
            capacityKg: capacityKg,
            weightMaxKg: weightMaxKg,
            capacityLabel: (displayCard && displayCard.capacityLabel) || it.capacityLabel || '',
          })
        })
        // Personalisation lines — one set per selected vessel that supports them.
        ;(entry.items || []).forEach(function (it) {
          if (!it || it.included || it.productId == null) return
          var pid = String(it.productId)
          var parentQty = memorialOrderQuantity(it)
          focusMemorialAddonProduct(entry, pid)
          ;['photo', 'nameplate', 'engraving'].forEach(function (type) {
            var addon = entry.addons && entry.addons[type]
            if (!addon || !addon.choiceLabel) return
            var editId = memorialAddonStepId(cat.key, type, pid)
            var lineAddonId = memorialAddonStepId(cat.key, type, pid)
            if (type === 'photo') {
              var photoSource = memorialAddonSourceForProduct(
                state, config, cat.key, catalog, 'photo', pid
              )
              var photoFlags = (photoSource && photoSource.flags) || {}
              addon.size = normalizePhotoPrintSize(addon.size || photoFlags.photoPrintSize)
              addon.orientation = effectivePhotoOrientation(photoFlags, addon)
              var photoDisplay = memorialPhotoSummaryDisplay(addon)
              var photoDeclined = String(addon.choiceId) === 'no'
              var photoVariant = photoDeclined ? null : resolvePhotoAddonVariant(addon, photoFlags)
              if (photoVariant && !addon.variant) addon.variant = photoVariant
              // Unlisted print fees are available:false in Liquid but still add
              // by variant id. Only skip draft/archived or tracked deny+0 (422).
              var photoCartId = feeCartVariantId(photoVariant)
              var photoProps = {}
              var photoParentId = memorialAddonParentLineId(
                state, config, cat, catalog, 'photo', pid
              )
              if (!photoDeclined && addon.photoUrl) {
                var photoHidden = {
                  'Photo URL': addon.photoUrl,
                  'Photo Size': addon.size,
                  'Photo Orientation': addon.orientation === 'landscape' ? 'landscape' : 'portrait',
                }
                if (addon.photoPrintUrl) photoHidden['Photo Print URL'] = addon.photoPrintUrl
                assignCartProperties(photoProps, photoHidden, true)
                // Peer cart line — name the memorial this print belongs to.
                var photoForTitle = String(it.styleTitle || it.label || '').trim()
                if (!photoForTitle && typeof AngelAshesBookingMemorials !== 'undefined') {
                  var photoForCard = AngelAshesBookingMemorials.findDisplayCardInCategory
                    ? AngelAshesBookingMemorials.findDisplayCardInCategory(cat, pid)
                    : AngelAshesBookingMemorials.findCardInCategory
                      ? AngelAshesBookingMemorials.findCardInCategory(cat, pid)
                      : null
                  if (photoForCard && photoForCard.title) {
                    photoForTitle = String(photoForCard.title).trim()
                  }
                }
                if (photoForTitle) {
                  assignCartProperties(photoProps, { 'Photo for': photoForTitle }, true)
                }
              }
              var photoFrame = null
              var photoMetal = null
              if (
                typeof AngelAshesBookingMemorials !== 'undefined' &&
                AngelAshesBookingMemorials.nameplateMetalForProduct
              ) {
                photoMetal = AngelAshesBookingMemorials.nameplateMetalForProduct(entry, pid)
              }
              if (
                typeof AngelAshesBookingMemorials !== 'undefined' &&
                AngelAshesBookingMemorials.resolvePhotoStepMockupFrame
              ) {
                photoFrame = AngelAshesBookingMemorials.resolvePhotoStepMockupFrame({
                  photoMockupFrame: photoFlags.photoMockupFrame || it.photoMockupFrame || null,
                  personaliseImage: photoFlags.personaliseImage || it.personaliseImage || null,
                  personaliseImageGold:
                    photoFlags.personaliseImageGold || it.personaliseImageGold || null,
                  personaliseImageSilver:
                    photoFlags.personaliseImageSilver || it.personaliseImageSilver || null,
                }, photoMetal)
              } else if (
                typeof AngelAshesBookingMemorials !== 'undefined' &&
                AngelAshesBookingMemorials.resolvePersonaliseMockupFrame
              ) {
                photoFrame = AngelAshesBookingMemorials.resolvePersonaliseMockupFrame({
                  photoMockupFrame: photoFlags.photoMockupFrame || it.photoMockupFrame || null,
                  personaliseImage: photoFlags.personaliseImage || it.personaliseImage || null,
                  personaliseImageGold:
                    photoFlags.personaliseImageGold || it.personaliseImageGold || null,
                  personaliseImageSilver:
                    photoFlags.personaliseImageSilver || it.personaliseImageSilver || null,
                }, photoMetal)
              }
              var photoNativeWide = false
              var photoNativeTall = false
              if (photoFrame) {
                var canChoosePhoto =
                  normalizePhotoOrientation(photoFlags.photoOrientation) === 'client_choice'
                // Match photoStepMockupPreviewOpts: client_choice → tall artboard.
                if (canChoosePhoto) photoNativeTall = true
                else photoNativeWide = true
              }
              if (!photoDeclined) {
                // Theme cart already falls back to `_Photo_URL`. Only write
                // `_Cart_Image` when it is a different merchandising thumb.
                var feePhotoUrl = compactCartImageUrl(addon.photoUrl)
                var feeCartImg =
                  compactCartImageUrl(addon.photoPrintUrl) ||
                  compactCartImageUrl(addon.localPreviewUrl) ||
                  compactCartImageUrl(photoFrame) ||
                  compactCartImageUrl(it.image)
                if (feeCartImg && feeCartImg !== feePhotoUrl) {
                  assignCartProperties(photoProps, { 'Cart Image': feeCartImg }, true)
                }
              }
              items.push({
                id: lineAddonId,
                editStepId: editId,
                groupLabel: (categorySummaryLabel || cat.reviewLabel || cat.title) + ' · Photo',
                memorialGroupKey: cat.key,
                memorialCategoryLabel: categorySummaryLabel,
                valueLabel: photoDisplay.valueLabel,
                photoPreviewUrl:
                  photoDisplay.photoPreviewUrl ||
                  addon.photoUrl ||
                  addon.localPreviewUrl ||
                  null,
                photoOrientation: photoDisplay.photoOrientation || null,
                photoMockupFrame: photoFrame || photoFlags.photoMockupFrame || null,
                photoMockupNativeWide: photoNativeWide,
                photoMockupNativeTall: photoNativeTall,
                hidePrice: !!photoDisplay.hidePrice,
                price: photoDeclined || photoDisplay.hidePrice
                  ? 0
                  : addonVariantPrice(photoVariant, parentQty),
                quantity: parentQty,
                variantId: photoCartId,
                properties: Object.keys(photoProps).length ? photoProps : undefined,
                nestedUnder: photoParentId,
                attachPropertiesToLineId: !photoDeclined && !photoCartId ? photoParentId : null,
              })
              return
            }
            if (String(addon.choiceId) === 'no') return
            if (type === 'nameplate') {
              clampNameplateInscription(addon)
              var npSource = memorialAddonSourceForProduct(
                state, config, cat.key, catalog, 'nameplate', pid
              )
              var npFlags = npSource && npSource.flags ? npSource.flags : null
              var npVariant = resolveNameplateAddonVariant(addon, npFlags)
              var npColourOptions = buildNameplateColourOptions(npFlags) || []
              var npColourOpt =
                npColourOptions.find(function (o) {
                  return String(o.id) === String(addon.choiceId)
                }) ||
                (addon.colour
                  ? npColourOptions.find(function (o) { return o.colour === addon.colour })
                  : null) ||
                null
              var npProps = {}
              if (addon.text) {
                assignCartProperties(npProps, {
                  'Nameplate Text': addon.text,
                  'Nameplate Text Line 2':
                    normalizeNameplateLines(addon.lines) === 2 && addon.textLine2
                      ? addon.textLine2
                      : '',
                  'Nameplate Font': nameplateFontSummaryLabel(addon.font),
                }, false)
              }
              // Preference-only included plates: colour is a production note
              // on the parent. Skip it when the memorial SKU already has
              // Gold/Silver variants — checkout shows Brushed Gold / Silver
              // on the variant line, so a second Nameplate Colour is duplicate.
              var parentHasMetalVariant = false
              if (
                typeof AngelAshesBookingMemorials !== 'undefined' &&
                AngelAshesBookingMemorials.isNameplateMetalVariant
              ) {
                var npParentCard = null
                if (AngelAshesBookingMemorials.findDisplayCardInCategory) {
                  npParentCard = AngelAshesBookingMemorials.findDisplayCardInCategory(
                    cat,
                    it.productId
                  )
                }
                if (!npParentCard && AngelAshesBookingMemorials.findCardInCategory) {
                  npParentCard = AngelAshesBookingMemorials.findCardInCategory(
                    cat,
                    it.productId
                  )
                }
                var npParentProduct = npParentCard && npParentCard.product
                var npParentVariants = npParentProduct && npParentProduct.variants
                var nvi
                for (nvi = 0; nvi < (npParentVariants || []).length; nvi++) {
                  if (
                    AngelAshesBookingMemorials.isNameplateMetalVariant(
                      npParentVariants[nvi],
                      npParentProduct
                    )
                  ) {
                    parentHasMetalVariant = true
                    break
                  }
                }
              }
              if (!npVariant && npColourOpt && !parentHasMetalVariant) {
                assignCartProperties(npProps, {
                  'Nameplate Colour':
                    String(npColourOpt.title || '').trim() ||
                    nameplateColourLabelFromFlags(npFlags, npColourOpt.colour),
                }, false)
              }
              var npParentId = memorialAddonParentLineId(
                state, config, cat, catalog, 'nameplate', pid
              )
              var npIncludedFree = !!(npFlags && npFlags.nameplateIncluded && !npVariant)
              var npPreviewOpt = npColourOpt || (addon.colour ? { colour: addon.colour } : null)
              items.push({
                id: lineAddonId,
                editStepId: editId,
                groupLabel: (categorySummaryLabel || cat.reviewLabel || cat.title) + ' · Nameplate',
                memorialGroupKey: cat.key,
                memorialCategoryLabel: categorySummaryLabel,
                valueLabel: nameplateSummaryLabelForAddon(addon, npFlags),
                price: npVariant ? (Number(npVariant.price) || 0) * parentQty : 0,
                quantity: parentQty,
                variantId: npVariant ? npVariant.id : null,
                included: npIncludedFree,
                properties: Object.keys(npProps).length ? npProps : undefined,
                nestedUnder: npParentId,
                nameplatePreviewGroupKey: cat.key,
                nameplatePreviewProductId: pid,
                nameplateTextLine1: addon.text || null,
                nameplateTextLine2: addon.textLine2 || null,
                nameplateFont: normalizeNameplateFont(addon.font),
                nameplateLines: normalizeNameplateLines(addon.lines),
                nameplateColour: (npPreviewOpt && npPreviewOpt.colour) || addon.colour || '',
                nameplatePreviewImage: nameplatePreviewImageForOption(npFlags, npPreviewOpt, config) || '',
                attachPropertiesToLineId: !npVariant ? npParentId : null,
              })
              return
            }
            var parentId = memorialAddonParentLineId(state, config, cat, catalog, type, pid)
            var engProps = {}
            var engLine1 = ''
            var engLine2 = ''
            if (type === 'engraving') {
              engLine1 = String(addon.text || '').trim()
              var engLines = normalizeNameplateLines(addon.lines)
              engLine2 = engLines === 2 ? String(addon.textLine2 || '').trim() : ''
              var parentTitle = memorialCustomerFacingStyleTitle({
                productId: it.productId,
                styleTitle: it.styleTitle,
                valueLabel: it.label,
                memorialGroupKey: cat.key,
              }, catalog) || String(it.styleTitle || it.label || '').trim()
              var engFor = engravingForDisplay(parentTitle, engLine1)
              if (engFor) assignCartProperties(engProps, { 'Engraving for': engFor }, false)
              if (engLine1) assignCartProperties(engProps, { 'Engraving name': engLine1 }, false)
              if (engLine2) assignCartProperties(engProps, { 'Engraving second line': engLine2 }, false)
            }
            var engCartId = feeCartVariantId(addon.variant)
            items.push({
              id: lineAddonId,
              editStepId: editId,
              groupLabel: (categorySummaryLabel || cat.reviewLabel || cat.title) + ' · ' + type.charAt(0).toUpperCase() + type.slice(1),
              memorialGroupKey: cat.key,
              memorialCategoryLabel: categorySummaryLabel,
              valueLabel: addon.choiceLabel,
              price: addonVariantPrice(addon.variant, parentQty),
              quantity: parentQty,
              variantId: engCartId,
              properties: Object.keys(engProps).length ? engProps : undefined,
              nestedUnder: parentId,
              // Magnifier opens text modal when inscription exists (summary / review).
              engravingPreviewGroupKey: (engLine1 || engLine2) ? cat.key : null,
              engravingPreviewProductId: (engLine1 || engLine2) ? pid : null,
              engravingTextLine1: engLine1 || null,
              engravingTextLine2: engLine2 || null,
              attachPropertiesToLineId: !engCartId ? parentId : null,
            })
          })
        })
        if (priorFocus) focusMemorialAddonProduct(entry, priorFocus)
      })
      if (state.portraitOffer && state.portraitOffer.variantId) {
        var portraitProps = {}
        if (state.portraitOffer.photoUrl) {
          assignCartProperties(portraitProps, {
            'Photo URL': state.portraitOffer.photoUrl,
          }, true)
        }
        items.push({
          id: 'memorial:portrait',
          editStepId: 'review',
          groupLabel: 'Portrait',
          memorialGroupKey: 'portrait',
          memorialCategoryLabel: 'Portrait',
          valueLabel: state.portraitOffer.label || 'Digital portrait',
          image: state.portraitOffer.photoUrl || state.portraitOffer.image || null,
          price: Number(state.portraitOffer.price) || 0,
          variantId: state.portraitOffer.variantId,
          properties: Object.keys(portraitProps).length ? portraitProps : undefined,
        })
      }
    })()

    if (config.flow !== 'shared' && state.returnSpeed.key) {
      var returnSpeedLabel = state.returnSpeed.label
      items.push({
        id: 'return-speed', editStepId: 'return-speed', groupLabel: 'Timing',
        valueLabel: returnSpeedSummaryLabel(returnSpeedLabel) || returnSpeedLabel,
        price: state.returnSpeed.variant ? Number(state.returnSpeed.variant.price) || 0 : 0,
        variantId: sellableVariantId(state.returnSpeed.variant),
        nestedUnder: cremationParentId,
      })
    }
    if (
      state.returnMethod.key &&
      (config.flow !== 'shared' || hasPurchasedMemorialItems(state, config))
    ) {
      var returnLabel = transportNoteLabelForReturn(state)
      var returnDisplay = returnSummaryLabel(state) || returnLabel
      var returnProps = {}
      var readyRange = ashesReadyEstimateRangeLabel(state)
      if (readyRange) {
        assignCartProperties(returnProps, { 'Estimated Ready': readyRange }, false)
      }
      items.push({
        id: 'return-method', editStepId: 'return-method', groupLabel: 'Return',
        valueLabel: returnDisplay,
        price: state.returnMethod.variant ? Number(state.returnMethod.variant.price) || 0 : 0,
        variantId: sellableVariantId(state.returnMethod.variant),
        nestedUnder: cremationParentId,
        properties: Object.keys(returnProps).length ? returnProps : undefined,
      })
    }

    return items
  }

  function nameplateFontSummaryLabel(fontId) {
    var id = normalizeNameplateFont ? normalizeNameplateFont(fontId) : String(fontId || '').trim().toLowerCase()
    var fonts = NAMEPLATE_FONTS || []
    for (var i = 0; i < fonts.length; i++) {
      if (fonts[i] && fonts[i].id === id) return fonts[i].label || ''
    }
    return id === 'lavanderia' || id === 'script' ? 'Script' : 'Print'
  }

  function memorialAddonTypeFromLine(line) {
    var parsed = parseMemorialAddonStepId(line && line.id)
    return parsed && parsed.type ? String(parsed.type) : ''
  }

  function engravingCollapsedMeta(line) {
    return 'Engraving'
  }

  function nameplateCollapsedMeta(line) {
    return 'Nameplate'
  }

  function photoCollapsedMeta(line) {
    var label = String((line && line.valueLabel) || '').trim()
    if (!label || /not required/i.test(label)) return ''
    if (/upload/i.test(label)) return label
    // Paid print fee — match the Printed photo card, not only "Portrait Photo".
    if (!line.hidePrice && Number(line.price) > 0) return 'Printed photo'
    return label
  }

  /** Display / total price for a memorial add-on. Independent of sellableVariantId. */

  function addonVariantPrice(variant, qty) {
    if (!variant) return 0
    var n = Math.floor(Number(qty) || 1)
    if (!(n > 0)) n = 1
    return (Number(variant.price) || 0) * n
  }

  function memorialOrderQuantity(it) {
    if (!it || it.included) return 1
    var n = Math.floor(Number(it.quantity) || 1)
    return n > 0 ? n : 1
  }

  /**
   * Liquid `available: false` is sold-out *or* Unlisted/unpublished.
   * /cart/add.js 422s tracked + deny + 0 qty. Unlisted fees with continue
   * selling / untracked / in-stock still add by variant id — post those.
   * Missing inventory fields keep the conservative skip (old JSON).
   */
  function variantProductStatus(variant) {
    return String((variant && variant.productStatus) || '').trim().toLowerCase()
  }

  function inventoryAllowsSale(variant) {
    if (!variant) return false
    var hasQty = Object.prototype.hasOwnProperty.call(variant, 'inventoryQuantity')
    var hasPolicy = Object.prototype.hasOwnProperty.call(variant, 'inventoryPolicy')
    var hasMgmt = Object.prototype.hasOwnProperty.call(variant, 'inventoryManagement')
    if (!hasQty && !hasPolicy && !hasMgmt) return false
    var untracked = hasMgmt && (variant.inventoryManagement == null || variant.inventoryManagement === '')
    if (untracked) return true
    if (hasPolicy && String(variant.inventoryPolicy || '').toLowerCase() === 'continue') return true
    if (hasQty) {
      var qty = Number(variant.inventoryQuantity)
      if (isFinite(qty) && qty > 0) return true
    }
    return false
  }

  /** True only when we know /cart/add.js will 422: tracked + deny + 0. */

  function isTrackedDenyZero(variant) {
    if (!variant) return false
    var hasQty = Object.prototype.hasOwnProperty.call(variant, 'inventoryQuantity')
    var hasMgmt = Object.prototype.hasOwnProperty.call(variant, 'inventoryManagement')
    if (!hasQty || !hasMgmt) return false
    var tracked = variant.inventoryManagement != null && variant.inventoryManagement !== ''
    if (!tracked) return false
    var policy = String(variant.inventoryPolicy || 'deny').toLowerCase()
    if (policy === 'continue') return false
    var qty = Number(variant.inventoryQuantity)
    return isFinite(qty) && qty <= 0
  }

  function isSellableCartVariant(variant) {
    if (!variant || variant.id == null) return false
    var status = variantProductStatus(variant)
    if (status === 'draft' || status === 'archived') return false
    if (variant.available !== false) return true
    return inventoryAllowsSale(variant)
  }

  function sellableVariantId(variant) {
    return isSellableCartVariant(variant) ? variant.id : null
  }

  /**
   * Photo / engraving fee SKUs are often Unlisted (Liquid available:false) so
   * they stay off the storefront. /cart/add.js still accepts the variant id
   * unless the product is draft/archived or tracked deny+0.
   */
  function feeCartVariantId(variant) {
    if (!variant || variant.id == null) return null
    var status = variantProductStatus(variant)
    if (status === 'draft' || status === 'archived') return null
    if (isTrackedDenyZero(variant)) return null
    return variant.id
  }

  var SPECIAL_INSTRUCTIONS_MAX = 1000

  function specialInstructionsOpen(state) {
    // Accordion chrome only — never infer open from note text.
    return !!(state && state.specialInstructionsOpen === true)
  }

  function specialInstructionsStoredText(state) {
    var s = String((state && state.specialInstructions) || '').trim()
    if (s.length > SPECIAL_INSTRUCTIONS_MAX) s = s.slice(0, SPECIAL_INSTRUCTIONS_MAX)
    return s
  }

  /** Always returns stored note text — accordion open/closed does not drop the payload. */
  function specialInstructionsText(state) {
    return specialInstructionsStoredText(state)
  }

  function specialInstructionsPreview(text, maxLen) {
    var s = String(text || '').replace(/\s+/g, ' ').trim()
    if (!s) return ''
    var lim = typeof maxLen === 'number' && maxLen > 0 ? maxLen : 72
    if (s.length <= lim) return s
    return s.slice(0, Math.max(1, lim - 1)).replace(/\s+\S*$/, '').replace(/[.,;:\s]+$/, '') + '\u2026'
  }

  function sharedAshesAckLabelHtml(state) {
    var pet = typeof petFirstNameRef === 'function' ? petFirstNameRef(state) : { name: '', ref: 'your pet' }
    var who = isUsablePetName(pet.name)
      ? escapeHtml(possessiveName(pet.name))
      : 'your pet\u2019s'
    return (
      'I understand ' +
      who +
      ' ashes will <strong>not</strong> be returned with shared cremation.'
    )
  }

  function chevronIconSvg() {
    return (
      '<svg class="baw-review-notes-chevron" viewBox="0 0 16 16" width="16" height="16" focusable="false" aria-hidden="true">' +
      '<path d="M3.2 5.8 8 10.6l4.8-4.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
    )
  }

  function engravingForDisplay(parentTitle, line1) {
    var title = String(parentTitle || '').trim()
    var name = String(line1 || '').trim()
    if (title && name) return title + ' \u2014 \u201c' + name + '\u201d'
    if (title) return title
    if (name) return '\u201c' + name + '\u201d'
    return ''
  }

  function renderReviewNotesHtml(state) {
    var storedNotes = specialInstructionsStoredText(state)
    var notesOpen = specialInstructionsOpen(state)
    var hasNote = !!storedNotes
    var preview = specialInstructionsPreview(storedNotes, 72)
    var primaryLabel = notesOpen
      ? 'Note for our care team'
      : hasNote
        ? 'Edit note for our care team'
        : 'Add a note for our care team'
    var countLabel = storedNotes.length + ' / ' + SPECIAL_INSTRUCTIONS_MAX
    var panelId = 'baw-special-instructions-panel'
    var headingId = 'baw-special-instructions-heading'
    var toggleId = 'baw-special-instructions-toggle'
    return (
      '<div class="baw-review-notes' + (notesOpen ? ' is-open' : '') + (hasNote ? ' has-note' : '') + '" data-baw-review-notes>' +
      '<button type="button" class="baw-review-notes-toggle" id="' + toggleId + '"' +
      ' data-baw-special-instructions-toggle' +
      ' aria-expanded="' + (notesOpen ? 'true' : 'false') + '"' +
      ' aria-controls="' + panelId + '"' +
      ' aria-label="' + escapeHtml(primaryLabel) + '">' +
      '<span class="baw-review-notes-toggle-copy">' +
      '<span class="baw-review-notes-toggle-primary" data-baw-special-instructions-primary>' +
      escapeHtml(primaryLabel) +
      '</span>' +
      '<span class="baw-review-notes-toggle-optional"' +
      (notesOpen || hasNote ? ' hidden' : '') +
      '>Optional</span>' +
      '<span class="baw-review-notes-toggle-preview" data-baw-special-instructions-preview' +
      (preview && !notesOpen ? '' : ' hidden') +
      '>' +
      escapeHtml(preview) +
      '</span>' +
      '</span>' +
      '<span class="baw-review-notes-toggle-icon" aria-hidden="true">' +
      chevronIconSvg() +
      '</span>' +
      '</button>' +
      '<div id="' + panelId + '" class="baw-review-notes-fields" role="region"' +
      ' aria-labelledby="' + headingId + '"' +
      (notesOpen ? '' : ' hidden') +
      '>' +
      '<p id="' + headingId + '" class="baw-visually-hidden">Note for our care team</p>' +
      '<label class="baw-visually-hidden" for="baw-special-instructions">Note for our care team</label>' +
      '<textarea id="baw-special-instructions" class="baw-textarea baw-review-notes-input" data-baw-special-instructions maxlength="' +
      SPECIAL_INSTRUCTIONS_MAX +
      '" rows="4" placeholder="Type your note here\u2026">' +
      escapeHtml(storedNotes) +
      '</textarea>' +
      '<div class="baw-review-notes-meta">' +
      '<span class="baw-review-notes-count" data-baw-special-instructions-count aria-live="polite">' +
      escapeHtml(countLabel) +
      '</span>' +
      '<button type="button" class="baw-review-notes-done" data-baw-special-instructions-done>Done</button>' +
      '</div>' +
      '</div>' +
      '</div>'
    )
  }

  function renderSharedAshesAckHtml(state, config) {
    if (!config || config.flow !== 'shared') return ''
    var checked = !!state.sharedAshesAcknowledged
    var invalid = !!state.sharedAshesAckInvalid
    var labelHtml = sharedAshesAckLabelHtml(state)
    return (
      '<div class="baw-review-shared-ack' + (invalid ? ' is-invalid' : '') + '"' +
      ' data-baw-shared-ashes-ack' +
      (invalid ? ' data-invalid="true"' : '') +
      '>' +
      '<label class="baw-review-shared-ack-label" for="baw-shared-ashes-ack">' +
      '<span class="baw-review-shared-ack-icon" aria-hidden="true">i</span>' +
      '<input id="baw-shared-ashes-ack" type="checkbox" class="baw-review-shared-ack-check"' +
      ' data-baw-shared-ashes-ack-check' +
      (checked ? ' checked' : '') +
      (invalid ? ' aria-invalid="true" aria-describedby="baw-shared-ashes-ack-error"' : '') +
      '>' +
      '<span class="baw-review-shared-ack-text">' + labelHtml + '</span>' +
      '</label>' +
      '<p id="baw-shared-ashes-ack-error" class="baw-review-shared-ack-error" data-baw-shared-ashes-ack-error' +
      ' role="alert"' +
      (invalid ? '' : ' hidden') +
      '>Please confirm this before continuing.</p>' +
      '</div>'
    )
  }

  /**
   * Optional care-team note, then shared ashes ack (when shared) — glued above Total.
   * Notes accordion opens downward with the toggle at the top of the panel.
   */
  function renderReviewCalloutsHtml(state, config) {
    return (
      '<div class="baw-review-callouts">' +
      renderReviewNotesHtml(state) +
      renderSharedAshesAckHtml(state, config) +
      '</div>'
    )
  }

  function addonPaidPrice(line) {
    if (!line || line.hidePrice || line.included) return 0
    return Number(line.price) || 0
  }

  /**
   * Quantity families (print packs / tin sets): summary uses the style title,
   * then ` × n` when the pack quantity is greater than one.
   * Ledger / cart titles stay on the Shopify product title.
   */
  function findQuantityFamilyCard(catalog, memorialGroupKey, productId) {
    var M = typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
    if (!M || !catalog || productId == null) return null
    var cat = catalog.byKey && memorialGroupKey ? catalog.byKey[memorialGroupKey] : null
    if (!cat) return null
    var pid = String(productId)
    var qtyType = M.CARD_OPTION_TYPES && M.CARD_OPTION_TYPES.QUANTITY
    var cards = cat.allCards || []
    var i
    var j
    var card
    for (i = 0; i < cards.length; i++) {
      card = cards[i]
      if (!card || card.optionType !== qtyType) continue
      if (String(card.productId) === pid || String(card.activeOptionId || '') === pid) return card
      var opts = card.options || []
      for (j = 0; j < opts.length; j++) {
        if (opts[j] && String(opts[j].id) === pid) return card
      }
      var members = card.swatchMembers || []
      for (j = 0; j < members.length; j++) {
        if (members[j] && String(members[j].productId) === pid) return card
      }
    }
    card = M.findCardInCategory ? M.findCardInCategory(cat, productId) : null
    return card && card.optionType === qtyType ? card : null
  }

  function memorialCustomerFacingStyleTitle(line, catalog, family) {
    var M = typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
    var card = family || null
    if (!card && M && catalog && line) {
      var cat = catalog.byKey && line.memorialGroupKey ? catalog.byKey[line.memorialGroupKey] : null
      if (cat && M.findDisplayCardInCategory) card = M.findDisplayCardInCategory(cat, line.productId)
      else if (cat && M.findCardInCategory) card = M.findCardInCategory(cat, line.productId)
    }
    var style = ''
    if (card && M && M.getMemorialDisplayTitle) style = String(M.getMemorialDisplayTitle(card) || '').trim()
    if (!style && card && card.styleTitle) style = String(card.styleTitle).trim()
    if (!style && card && card.title) style = String(card.title).trim()
    if (!style && line && line.styleTitle) style = String(line.styleTitle).trim()
    if (!style) style = String((line && line.valueLabel) || '').trim()
    return style
  }

  function memorialQuantityPackSize(line, family) {
    var M = typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
    if (!family) return 0
    var pid = line && line.productId != null ? String(line.productId) : String(family.activeOptionId || '')
    var opt = M && M.findCardOption ? M.findCardOption(family, pid) : null
    if (opt && Number(opt.quantity) > 0) return Math.floor(Number(opt.quantity))
    if (opt && opt.swatch && opt.swatch.type === 'number' && Number(opt.swatch.value) > 0) {
      return Math.floor(Number(opt.swatch.value))
    }
    var metaMatch = String((line && line.variantMeta) || '').match(/^(\d+)/)
    if (metaMatch) return Number(metaMatch[1])
    return 0
  }

  function memorialOffersOrderQuantity(line, catalog) {
    if (!line || line.included) return false
    var M = typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
    if (!M || !M.categoryAllowsOrderQuantity || !catalog) return false
    var cat = catalog.byKey && line.memorialGroupKey ? catalog.byKey[line.memorialGroupKey] : null
    if (!M.categoryAllowsOrderQuantity(cat)) return false
    var card = null
    if (cat && M.findDisplayCardInCategory) card = M.findDisplayCardInCategory(cat, line.productId)
    else if (cat && M.findCardInCategory) card = M.findCardInCategory(cat, line.productId)
    if (card && String(card.optionType || '') === 'quantity') return false
    return true
  }

  function memorialQuantityDisplayTitle(line, catalog) {
    var family = findQuantityFamilyCard(
      catalog,
      line && line.memorialGroupKey,
      line && line.productId
    )
    if (!family) return ''
    var qty = memorialQuantityPackSize(line, family)
    if (!(qty > 0)) return ''
    var M = typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
    var style = memorialCustomerFacingStyleTitle(line, catalog, family)
    if (M && M.formatMemorialSummaryLabel) return M.formatMemorialSummaryLabel(style, qty, true)
    return qty > 1 ? style + ' \u00d7 ' + qty : style
  }

  function collapseOneMemorialForSummary(product, addons, catalog, state) {
    var metaLines = []
    var family = findQuantityFamilyCard(
      catalog,
      product && product.memorialGroupKey,
      product && product.productId
    )
    var M = typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
    var style = memorialCustomerFacingStyleTitle(product, catalog, family)
    var offersQty = false
    var qty = 1
    if (family) {
      offersQty = true
      var packQty = memorialQuantityPackSize(product, family)
      qty = packQty > 0 ? packQty : 1
    } else if (memorialOffersOrderQuantity(product, catalog)) {
      offersQty = true
      qty = memorialOrderQuantity(product)
    }
    var title = M && M.formatMemorialSummaryLabel
      ? M.formatMemorialSummaryLabel(style, qty, offersQty)
      : (offersQty && qty > 1 ? style + ' \u00d7 ' + qty : style)
    var colour = family ? '' : String((product && product.variantMeta) || '').trim()
    if (
      colour &&
      typeof AngelAshesBookingMemorials !== 'undefined' &&
      AngelAshesBookingMemorials.isWeightSizeVariantMeta &&
      AngelAshesBookingMemorials.isWeightSizeVariantMeta(colour)
    ) {
      colour = ''
    }
    if (colour && colour !== title) {
      metaLines.push({ text: colour })
    }
    var packagingCard = family
    if (!packagingCard && M && catalog && product) {
      var packagingCat =
        catalog.byKey && product.memorialGroupKey
          ? catalog.byKey[product.memorialGroupKey]
          : null
      if (packagingCat && M.findDisplayCardInCategory) {
        packagingCard = M.findDisplayCardInCategory(packagingCat, product.productId)
      } else if (packagingCat && M.findCardInCategory) {
        packagingCard = M.findCardInCategory(packagingCat, product.productId)
      }
    }
    var packagingSupporting =
      packagingCard && packagingCard.supporting
        ? String(packagingCard.supporting).trim()
        : ''
    if (M && M.includedMemorialPackagingLabels) {
      M.includedMemorialPackagingLabels(style, packagingSupporting).forEach(function (label) {
        if (!label) return
        metaLines.push({
          text: label,
          included: true,
          hidePrice: true,
        })
      })
    }
    var combined = product && product.included ? 0 : (Number(product && product.price) || 0)
    ;(addons || []).forEach(function (addon) {
      if (!addon) return
      var addonPrice = addonPaidPrice(addon)
      var type = memorialAddonTypeFromLine(addon)
      var text = ''
      var preview = null
      if (type === 'engraving') {
        text = engravingCollapsedMeta(addon)
        if (addon.engravingPreviewGroupKey) {
          preview = {
            kind: 'engraving',
            groupKey: addon.engravingPreviewGroupKey,
            productId: addon.engravingPreviewProductId,
            text: addon.engravingTextLine1 || '',
            textLine2: addon.engravingTextLine2 || '',
          }
        }
      } else if (type === 'nameplate') {
        text = nameplateCollapsedMeta(addon)
        preview = {
          kind: 'nameplate',
          groupKey: addon.nameplatePreviewGroupKey || addon.memorialGroupKey || '',
          productId: addon.nameplatePreviewProductId != null
            ? addon.nameplatePreviewProductId
            : addon.productId,
          text: addon.nameplateTextLine1 || addon.text || '',
          textLine2: addon.nameplateTextLine2 || addon.textLine2 || '',
          font: addon.nameplateFont || addon.font || '',
          lines: addon.nameplateLines || addon.lines ||
            (addon.nameplateTextLine2 || addon.textLine2 ? 2 : 1),
          colour: addon.nameplateColour || addon.colour || '',
          image: addon.nameplatePreviewImage || '',
        }
      } else if (type === 'photo') {
        text = photoCollapsedMeta(addon)
        if (addon.photoPreviewUrl || addon.photoMockupFrame) {
          preview = {
            kind: 'photo',
            url: addon.photoPreviewUrl || '',
            orientation: addon.photoOrientation,
            frameUrl: addon.photoMockupFrame || '',
            nativeWide: !!addon.photoMockupNativeWide,
            nativeTall: !!addon.photoMockupNativeTall,
          }
        }
      } else {
        text = String(addon.valueLabel || '').trim()
      }
      if (!text && !preview) return
      metaLines.push({
        text: text,
        preview: preview,
        editStepId: addon.editStepId || null,
        price: addonPrice,
        included: !!addon.included,
        hidePrice: !!addon.hidePrice,
      })
    })
    var photoStateUrl = ''
    var photoStateOrient = ''
    if (state && product && product.productId != null) {
      var photoEntry = getMemorialEntry(state, product.memorialGroupKey)
      var photoBuckets = photoEntry && photoEntry.itemAddons
      var photoBucket = photoBuckets && photoBuckets[String(product.productId)]
      var photoState = photoBucket && photoBucket.photo
      if (photoState && String(photoState.choiceId || '') !== 'no') {
        photoStateUrl = String(photoState.photoUrl || photoState.localPreviewUrl || '').trim()
        photoStateOrient = String(photoState.orientation || '').trim().toLowerCase() === 'landscape'
          ? 'landscape'
          : 'portrait'
      }
    }
    var photoThumbUrl = ''
    var photoThumbFrame = ''
    var photoThumbWide = false
    var photoThumbTall = false
    var photoThumbOrient = 'portrait'
    if (photoStateUrl) {
      metaLines.forEach(function (meta) {
        if (!meta || !meta.preview || meta.preview.kind !== 'photo') return
        if (!meta.preview.url) meta.preview.url = photoStateUrl
        if (!photoThumbUrl) {
          photoThumbUrl = meta.preview.url || photoStateUrl
          photoThumbFrame = meta.preview.frameUrl || ''
          photoThumbWide = !!meta.preview.nativeWide
          photoThumbTall = !!meta.preview.nativeTall
          photoThumbOrient = meta.preview.orientation === 'landscape' ? 'landscape' : photoStateOrient
        }
      })
      if (!photoThumbUrl && product.personaliseThumb) {
        photoThumbUrl = photoStateUrl
        photoThumbFrame = String((product && product.image) || '').trim()
        photoThumbOrient = photoStateOrient || 'portrait'
        var tributeThumb = /photo tribute/i.test(String((product && product.valueLabel) || ''))
        var urnThumb = String((product && product.memorialGroupKey) || '') === 'urn'
        photoThumbTall = !!(tributeThumb || urnThumb)
        photoThumbWide = !photoThumbTall
      }
    }
    var included = !!(product && product.included) && combined <= 0
    return Object.assign({}, product, {
      collapsed: true,
      nested: false,
      valueLabel: title,
      variantMeta: colour,
      price: included ? 0 : combined,
      included: included,
      hidePrice: false,
      metaLines: metaLines,
      photoPreviewUrl: photoThumbUrl || null,
      photoOrientation: photoThumbUrl ? photoThumbOrient : null,
      photoMockupFrame: photoThumbFrame || null,
      photoMockupNativeWide: !!photoThumbWide,
      photoMockupNativeTall: !!photoThumbTall,
      nameplatePreviewGroupKey: null,
      engravingPreviewGroupKey: null,
      ashesTag: null,
      capacityRole: product && product.capacityRole,
      capacityKg: product && product.capacityKg != null ? product.capacityKg : null,
      weightMaxKg: product && product.weightMaxKg != null ? product.weightMaxKg : null,
      capacityLabel: product && product.capacityLabel,
      personaliseThumb: !!(product && product.personaliseThumb),
    })
  }

  /**
   * Display-only: one row per physical memorial (product + nested add-ons).
   * Ledger / Shopify line items stay unchanged.
   */

  function collapseMemorialsForSummary(lines, catalog, state) {
    var out = []
    var list = lines || []
    var i = 0
    while (i < list.length) {
      var line = list[i]
      if (!line) {
        i += 1
        continue
      }
      if (line.isPlacement || String(line.id || '').indexOf(':ashes-placement') !== -1) {
        i += 1
        continue
      }
      if (isMemorialAddonLineId(line.id) || line.nested) {
        i += 1
        continue
      }
      if (isNoKeepsakeLabel(line.valueLabel) && !line.variantId && !line.included) {
        i += 1
        continue
      }
      var addons = []
      i += 1
      while (i < list.length) {
        var next = list[i]
        if (!next) break
        if (next.isPlacement || String(next.id || '').indexOf(':ashes-placement') !== -1) break
        if (!(isMemorialAddonLineId(next.id) || next.nested)) break
        addons.push(next)
        i += 1
      }
      out.push(collapseOneMemorialForSummary(line, addons, catalog, state))
    }
    return out
  }

  /**
   * Concierge rail sections — groups ledger lines for progressive display.
   * Cart/checkout still use the flat ledger from buildLedger.
   */

  function buildSummarySections(items, state, config) {
    var choice = (items || []).filter(function (i) { return i && !i.isPetHeader && !i.isPending })
    var byId = {}
    choice.forEach(function (i) { byId[i.id] = i })

    var sections = []
    var arrivalPath = !!(state && isLonsdaleTransport(state))

    if (byId.cremation) {
      // Quiet rail: CREMATION / Individual · Water · 30 kg — cart keeps variant title.
      var cremationLine = Object.assign({}, byId.cremation, {
        valueLabel: cremationRailValueLabel(state, config) || byId.cremation.valueLabel,
      })
      sections.push({
        id: 'cremation',
        title: 'Cremation',
        editStepId: byId.cremation.editStepId,
        lines: [cremationLine],
      })
    }

    var transportLines = []
    if (byId['transport-main'] && arrivalPath) {
      // Arrival path: Bring to Lonsdale · 5 min on one line.
      var mainLine = byId['transport-main']
      var arrivalLabel = familyFacingTransportCategoryLabel(state) || LONSDALE_FAMILY_LABEL
      var durationLabel = lonsdaleServiceSummaryLabel(state)
      var arrivalValue = durationLabel && durationLabel !== arrivalLabel
        ? arrivalLabel + ' · ' + durationLabel
        : arrivalLabel
      transportLines.push(Object.assign({}, mainLine, { valueLabel: arrivalValue }))
      if (byId['transport-sub']) {
        var subText = String(byId['transport-sub'].valueLabel || '')
        if (!/goodbye/i.test(subText) && !/^\d+\s*min$/i.test(subText.trim())) {
          transportLines.push(byId['transport-sub'])
        }
      }
    } else if (byId['transport-main']) {
      // Care arrangements: one compact service line (Home · Standard). Sub is already in the summary label.
      var careMain = byId['transport-main']
      var carePrimary = compactCareArrangementsServiceLabel(careMain.valueLabel)
      transportLines.push(Object.assign({}, careMain, { valueLabel: carePrimary }))
    }
    // Summary display only: combine date + time on one calm line (ledger stays separate).
    // Compact sidebar dates (no year / denser ranges) — Review + cart keep fuller labels.
    var transportDate = byId['transport-date']
    var transportTime = byId['transport-time']
    var transportYmd = state && state.transport && state.transport.date ? state.transport.date : ''
    if (transportDate && transportTime) {
      var datePart = transportYmd
        ? formatSummaryDateLabel(transportYmd)
        : String(transportDate.valueLabel || '').replace(/\s+\d{4}\s*$/, '')
      var whenLabel = datePart + ' · ' + (transportTime.valueLabel || '')
      if (!arrivalPath && transportLines.length) {
        transportLines[0] = Object.assign({}, transportLines[0], {
          valueLabel: String(transportLines[0].valueLabel || '').trim() + ' · ' + whenLabel,
        })
      } else {
        transportLines.push({
          id: 'transport-datetime',
          editStepId: transportDate.editStepId || transportTime.editStepId,
          valueLabel: whenLabel,
          price: 0,
        })
      }
    } else if (transportDate) {
      // Quiet rail: vet numeric range when known; else the ready-from / requested date alone.
      // Skip qualitative tile timing (Same-Day “Today, weekends…”, “Up to 7 days”, etc.).
      var timeframe = collectionTimeframeForState(state)
      var dateOnlyLabel = ''
      if (timeframe && timeframe.rangeLabel && isVetTransport(state)) {
        dateOnlyLabel =
          timeframe.startYmd && timeframe.endYmd
            ? formatSummaryDateRange(timeframe.startYmd, timeframe.endYmd)
            : timeframe.rangeLabel
      } else if (transportYmd) {
        dateOnlyLabel = formatSummaryDateLabel(transportYmd)
      } else {
        dateOnlyLabel = String(transportDate.valueLabel || '').replace(/\s+\d{4}\s*$/, '')
      }
      if (!arrivalPath && transportLines.length && dateOnlyLabel) {
        transportLines[0] = Object.assign({}, transportLines[0], {
          valueLabel: String(transportLines[0].valueLabel || '').trim() + ' · ' + dateOnlyLabel,
        })
      } else if (dateOnlyLabel) {
        transportLines.push(
          Object.assign({}, transportDate, { valueLabel: dateOnlyLabel })
        )
      }
    } else if (transportTime) {
      if (!arrivalPath && transportLines.length) {
        transportLines[0] = Object.assign({}, transportLines[0], {
          valueLabel:
            String(transportLines[0].valueLabel || '').trim() +
            ' · ' +
            String(transportTime.valueLabel || '').trim(),
        })
      } else {
        transportLines.push(transportTime)
      }
    }
    ;['transport-vet', 'transport-address'].forEach(function (id) {
      if (!byId[id]) return
      if (id === 'transport-address') {
        // Compact street + suburb on the rail; cart properties keep the full address.
        transportLines.push(
          Object.assign({}, byId[id], {
            valueLabel: formatSummaryAddress(byId[id].valueLabel || ''),
          })
        )
      } else {
        // Vet clinic names stay full — do not abbreviate.
        transportLines.push(byId[id])
      }
    })
    if (transportLines.length) {
      var transportEdit =
        (byId['transport-main'] && byId['transport-main'].editStepId) ||
        (byId['transport-sub'] && byId['transport-sub'].editStepId) ||
        transportLines[0].editStepId
      sections.push({
        id: 'transport',
        title: arrivalPath ? 'Arrival' : 'Care arrangements',
        editStepId: transportEdit,
        lines: transportLines,
      })
    }

    var memorialLines = choice.filter(function (i) {
      if (String(i.id || '').indexOf('memorial:') !== 0) return false
      // Included keepsakes (when explicitly selected) hide from the rail until
      // the family reaches that memorial step (same pattern as return-speed).
      if (i.included) {
        var memKey = String(i.id || '').split(':')[1]
        if (memKey && !hasReachedWizardStep(state, config, 'memorial:' + memKey)) return false
      }
      return true
    })
    memorialLines = collapseMemorialsForSummary(
      orderMemorialLinesForSummary(memorialLines),
      getMemorialCatalog(state, config),
      state
    )
    if (memorialLines.length) {
      sections.push({
        id: 'memorials',
        title: 'Memorials',
        editStepId: memorialLines[0].editStepId,
        lines: memorialLines,
        showCategorySubheads: false,
      })
    }

    var placementLines = ashesPlacementSummaryLines
      ? ashesPlacementSummaryLines(state)
      : (ashesPlacementSummaryLine && ashesPlacementSummaryLine(state)
        ? [ashesPlacementSummaryLine(state)]
        : [])
    if (placementLines.length) {
      sections.push({
        id: 'ashes-placement',
        title: 'Ashes placement',
        editStepId: null,
        lines: placementLines,
      })
    }

    var ashesLines = []
    if (byId['return-speed']) {
      var speedLine = byId['return-speed']
      var speedLabel = String(speedLine.valueLabel || '').trim()
      var ashesEstimate = ashesReadyEstimateRangeForState(state)
      var rangeLabel = ashesEstimate && ashesEstimate.startYmd && ashesEstimate.endYmd
        ? formatSummaryDateRange(ashesEstimate.startYmd, ashesEstimate.endYmd)
        : ''
      ashesLines.push(Object.assign({}, speedLine, {
        valueLabel: rangeLabel ? speedLabel + ' · ' + rangeLabel : speedLabel,
      }))
    }
    if (byId['return-method']) ashesLines.push(byId['return-method'])
    if (ashesLines.length) {
      sections.push({
        id: 'ashes-return',
        title: memorialReturnSectionTitle(state, config),
        editStepId: ashesLines[0].editStepId,
        lines: ashesLines,
      })
    }

    return sections
  }

  function transportNoteLabelForReturn(state) {
    return state.returnMethod.label || ''
  }

  function returnSpeedDayBounds(label) {
    var parsed = parseReturnSpeedLabel(label)
    var short = parsed.daysShort || ''
    var range = short.match(/(\d+)\s*[–\-]\s*(\d+)/)
    var working = /\bworking\b/i.test(String(label || ''))
    if (range) {
      return { minDays: Number(range[1]), maxDays: Number(range[2]), isWorkingDays: working }
    }
    var single = short.match(/(\d+)\s*days?/i)
    if (single) {
      var n = Number(single[1])
      return { minDays: n, maxDays: n, isWorkingDays: working }
    }
    if (parsed.isPriority) return { minDays: 3, maxDays: 5, isWorkingDays: false }
    if (label) return { minDays: 10, maxDays: 14, isWorkingDays: false }
    return null
  }

  /**
   * Expected ashes-ready window from conservative “in care” start + return SLA.
   * In care = end of vet collection estimate (when ranged), home requested date,
   * or Lonsdale arrival date.
   */

  function ashesReadyEstimateRangeForState(state) {
    if (!state || !state.returnSpeed || !state.returnSpeed.key) return null
    var bounds = returnSpeedDayBounds(state.returnSpeed.label)
    if (!bounds) return null

    var inCareYmd = null
    var collectionEst = collectionEstimateRangeForState(state)
    if (collectionEst && collectionEst.endYmd) {
      inCareYmd = collectionEst.endYmd
    } else if (
      state.transport &&
      state.transport.date &&
      (isLonsdaleTransport(state) || state.transport.categoryId === 'home')
    ) {
      inCareYmd = state.transport.date
    }
    if (!inCareYmd) return null

    var start = parseYmdLocal(inCareYmd)
    if (!start) return null
    var add = bounds.isWorkingDays ? addWorkingDaysLocal : addDaysLocal
    return {
      startYmd: toYmd(add(start, bounds.minDays)),
      endYmd: toYmd(add(start, bounds.maxDays)),
    }
  }

  /** Compact ashes-ready range for summary/review — same calc as the return-speed footer. */

  function ashesReadyEstimateRangeLabel(state) {
    var estimate = ashesReadyEstimateRangeForState(state)
    if (!estimate) return ''
    if (estimate.startYmd === estimate.endYmd) return formatAuDateDmy(estimate.startYmd)
    return formatAuDateDmy(estimate.startYmd) + ' \u2013 ' + formatAuDateDmy(estimate.endYmd)
  }

  /** Quiet ashes-ready estimate above Continue on the return-speed step. */

  function ashesReturnFooterNotesHtml(state, config) {
    var estimate = ashesReadyEstimateRangeForState(state)
    if (!estimate) return ''
    var pet = petFirstNameRef(state)
    var possess = isUsablePetName(pet.name) ? possessiveName(pet.name) : 'your pet\u2019s'
    var leadTemplate = stepCopyText(config, 'guidanceAshesReadyEstimate')
    if (!leadTemplate) return ''
    var leadIn = leadTemplate
      .replace(/\{pet_possessive\}/g, possess)
      .replace(/\{pet\}/g, pet.ref)
    return wrapGuidanceBarHtml(
      '<p class="baw-guidance-line baw-step-footer-note baw-guidance-primary baw-guidance-line--emphasis baw-step-footer-note--emphasis">' +
        escapeHtml(leadIn) +
        '</p>' +
      '<p class="baw-guidance-line baw-step-footer-note baw-guidance-date-range baw-guidance-line--emphasis baw-step-footer-note--emphasis">' +
        '<strong>' +
        escapeHtml(formatCollectionDateShort(estimate.startYmd)) +
        '</strong>' +
        escapeHtml(' and ') +
        '<strong>' +
        escapeHtml(formatCollectionDateShort(estimate.endYmd)) +
        '</strong>' +
        escapeHtml('.') +
        '</p>',
      { variant: 'timing' }
    )
  }

  // Quiet rail / review — method only; cart keeps the Shopify weight-band variant title.

  function cremationSummaryLabel(state) {
    if (!state || !state.cremationVariant) return ''
    if (state.cremationType === 'water') return 'Water'
    if (state.cremationType === 'flame') return 'Flame'
    // Shared / communal: section title already names the path; weight appends on the cremation line.
    return 'Shared'
  }

  /** Display weight for quiet rail / review (e.g. "30 kg"); empty when unset. */

  function petWeightSummaryLabel(state) {
    if (!state || !state.pet) return ''
    var w = state.pet.weightKg
    if (w == null || w === '' || isNaN(Number(w))) return ''
    var kg = Number(w)
    if (!(kg > 0)) return ''
    return String(w).replace(/\.0$/, '') + ' kg'
  }

  // Quiet rail + Review: CREMATION → "Individual · Water · 30 kg" (cart keeps the Shopify variant title).

  function cremationRailValueLabel(state, config) {
    var method = cremationSummaryLabel(state)
    if (!method) return ''
    var base =
      method === 'Shared' || (config && config.flow === 'shared')
        ? method
        : 'Individual · ' + method
    var weight = petWeightSummaryLabel(state)
    return weight ? base + ' · ' + weight : base
  }

  // Quiet rail / review — option title with compact ashes-ready dates on the same line.
  // Strip trailing " Return" so Ashes return · Priority (not "Priority Return").
  // Tiles keep the fuller title; cart still uses state.returnSpeed.label.

  function returnSpeedSummaryLabel(label) {
    var parsed = parseReturnSpeedLabel(label)
    var title = parsed.isPriority ? 'Priority Return' : (parsed.title || 'Standard')
    return String(title || '').replace(/\s+Return$/i, '')
  }

  // Review step — same title as the quiet rail (date range is shown via valueHint).

  function returnSpeedReviewLabel(label) {
    return returnSpeedSummaryLabel(label)
  }

  // Review display only — Theme Editor memorial titles stay intact on the step / cart.

  function memorialReviewGroupLabel(label) {
    return String(label || '').replace(/^choose\s+a\s+keepsake\b/i, 'Keepsake')
  }

  // Review-only label/value map — does not mutate ledger / cart properties.

  function reviewRowDisplay(item, state, config) {
    var groupLabel = item.groupLabel
    var valueLabel = item.valueLabel
    var valueHint = ''
    if (item.id === 'cremation') {
      // Match sidebar: CREMATION / Individual · Water · 30 kg (not INDIVIDUAL CREMATION / Water).
      groupLabel = 'Cremation'
      valueLabel = cremationRailValueLabel(state, config) || cremationSummaryLabel(state) || item.valueLabel
    } else if (item.id === 'transport-date') {
      // Home: preferred single date (from dateLabel). Vet: ready-from window. Else: ledger label.
      groupLabel = isVetTransport(state)
        ? 'Ready for collection from'
        : (item.groupLabel || 'Collection Date')
      var tf = collectionTimeframeForState(state)
      // Vet: show numeric range when known. Home: keep the single requested date.
      if (tf && tf.rangeLabel && isVetTransport(state)) {
        valueLabel = tf.rangeLabel
        valueHint = collectionInCareEmailHelper(state, config)
      } else if (tf && tf.helper && isVetTransport(state)) {
        valueHint = tf.helper
      }
    } else if (item.id === 'transport-vet' || item.id === 'transport-location') {
      groupLabel = 'Collection Location'
      if (item.id === 'transport-vet' && state.transport && state.transport.vetClinic) {
        valueLabel = state.transport.vetClinic
        if (state.transport.vetAddress) {
          valueLabel += '\n' + formatPickupAddress(state.transport.vetAddress)
        }
      }
    } else if (item.id === 'transport-address') {
      groupLabel = 'Collection Address'
    } else if (item.id === 'return-speed') {
      groupLabel = 'Estimated ashes return'
      valueLabel = returnSpeedReviewLabel(state.returnSpeed && state.returnSpeed.label) || item.valueLabel
      var ashesEstimate = ashesReadyEstimateRangeForState(state)
      var ashesRange = ashesEstimate && ashesEstimate.startYmd && ashesEstimate.endYmd
        ? formatSummaryDateRange(ashesEstimate.startYmd, ashesEstimate.endYmd)
        : ''
      if (ashesRange) valueLabel = String(valueLabel || '').trim() + ' · ' + ashesRange
    } else if (String(item.id || '').indexOf('memorial:') === 0) {
      groupLabel = memorialReviewGroupLabel(item.groupLabel)
    }
    return { groupLabel: groupLabel, valueLabel: valueLabel, valueHint: valueHint }
  }

  // Review list only — injects Lonsdale Collection Location; cart ledger unchanged.

  function buildReviewItems(items, state) {
    var out = []
    var hasLocationRow = (items || []).some(function (i) {
      return i && (i.id === 'transport-vet' || i.id === 'transport-address')
    })
    var insertedLonsdale = false
    var lonsdaleLocation = {
      id: 'transport-location',
      editStepId: 'transport-details',
      groupLabel: 'Collection Location',
      valueLabel: 'Angel Ashes Lonsdale',
      price: 0,
    }

    ;(items || []).forEach(function (item) {
      if (!item || item.isPetHeader) return
      if (
        !insertedLonsdale &&
        !hasLocationRow &&
        isLonsdaleTransport(state) &&
        (item.id === 'transport-date' || item.id === 'transport-time')
      ) {
        out.push(lonsdaleLocation)
        insertedLonsdale = true
      }
      out.push(item)
    })

    if (!insertedLonsdale && !hasLocationRow && isLonsdaleTransport(state)) {
      var insertAt = -1
      for (var i = 0; i < out.length; i++) {
        if (out[i].id === 'transport-main' || out[i].id === 'transport-sub') insertAt = i
      }
      if (insertAt >= 0) out.splice(insertAt + 1, 0, lonsdaleLocation)
      else out.push(lonsdaleLocation)
    }
    return out
  }

  // Return-speed option cards — fuller timeframe under the title.

  function returnSpeedTileDesc(parsed) {
    if (parsed && parsed.daysShort) return 'Expected within ' + parsed.daysShort
    return ''
  }

  // Quiet rail / review copy — cart / Return Method attribute keep the fuller label.
  // Home Delivery keeps Metro Adelaide on the tile only; location cards join title · desc.

  function returnSummaryLabel(state) {
    var label = String(state.returnMethod.label || '').replace(/\s+/g, ' ').trim()
    if (!label) return ''
    var mapped = mapReturnMethodDisplay(label, state.returnMethod)
    var title = mapped.title || label
    var kind = classifyReturnMethodKind(state.returnMethod)
    if (mapped.desc && kind !== 'home-delivery') return title + ' · ' + mapped.desc
    return title
  }

  /**
   * Paid home/shipping delivery (fee charged) vs free collection / pickup.
   * Collection locations (Lonsdale, Pet Universe, etc.) stay Collection even when Included.
   */

  function isPaidMemorialDelivery(state) {
    if (!state || !state.returnMethod || !state.returnMethod.key) return false
    if (typeof classifyReturnMethodKind === 'function' &&
        classifyReturnMethodKind(state.returnMethod) === 'home-delivery') {
      return true
    }
    var price = state.returnMethod.variant ? Number(state.returnMethod.variant.price) || 0 : 0
    if (!(price > 0)) return false
    var blob = [
      state.returnMethod.key,
      state.returnMethod.label,
      state.returnMethod.variant && state.returnMethod.variant.title,
    ].filter(Boolean).join(' ')
    return /deliver|shipping|postage|courier|ship\b/i.test(blob)
  }

  /**
   * Summary / review section heading for ashes-return.
   * Memorial Delivery only when the customer pays for delivery; otherwise Memorial Collection.
   * Individual timing-only (speed chosen, method not yet) keeps Estimated ashes return.
   */

  function memorialReturnSectionTitle(state, config) {
    if (isPaidMemorialDelivery(state)) return 'Memorial Delivery'
    if (state && state.returnMethod && state.returnMethod.key) return 'Memorial Collection'
    if (config && config.flow === 'shared') return 'Memorial Collection'
    return 'Estimated ashes return'
  }

  function ledgerTotal(items) {
    return items.reduce(function (sum, i) { return sum + (Number(i.price) || 0) }, 0)
  }

  /* -------------------- Review trust + payment marks (Theme Editor) -------------------- */

  function reviewTrustConfig(config) {
    return (config && config.reviewTrust) || {}
  }

  function formatReviewCountLabel(count) {
    var s = String(count || '').trim()
    if (!s) return ''
    var m = s.match(/^(\d+)(\+?)$/)
    if (!m) return s
    var withCommas = m[1].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return withCommas + (m[2] || '')
  }

  function renderReviewTrustHtml(config) {
    var trust = reviewTrustConfig(config)
    var score = String(trust.ratingScore || '').trim()
    if (!score) return ''
    var countLabel = formatReviewCountLabel(trust.reviewCount)
    var scoreNum = parseFloat(score)
    // Round half-up for filled stars (4.4 → 4, 4.5+ → 5). Non-numeric scores still show 5.
    var filled = isFinite(scoreNum) ? Math.max(0, Math.min(5, Math.round(scoreNum))) : 5
    var stars = ''
    for (var i = 0; i < 5; i++) {
      stars +=
        '<span class="baw-review-star' + (i < filled ? ' is-filled' : '') + '" aria-hidden="true">' +
        '<svg width="14" height="14" viewBox="0 0 12 12" fill="currentColor">' +
        '<path d="M6 0.8l1.4 3.1 3.4.4-2.5 2.3.7 3.3L6 8.3 2.9 9.9l.7-3.3L1.1 4.3l3.4-.4L6 .8z"/>' +
        '</svg></span>'
    }
    var meta = countLabel ? 'from ' + countLabel + ' customer reviews' : ''
    var ariaLabel = score + ' out of 5'
    if (meta) ariaLabel += ' ' + meta
    return (
      '<div class="baw-review-trust" role="group" aria-label="' + escapeHtml(ariaLabel) + '">' +
      '<div class="baw-review-trust-score">' +
      '<span class="baw-review-trust-stars" aria-hidden="true">' + stars + '</span>' +
      '<span class="baw-review-trust-value">' + escapeHtml(score) + '</span>' +
      (meta
        ? '<span class="baw-review-trust-meta">' + escapeHtml(meta) + '</span>'
        : '') +
      '</div>' +
      '</div>'
    )
  }

  // Official Shopify payment SVGs are parked in the section (payment_type_svg_tag —
  // same artwork as activemerchant/payment_icons). Live Review clones those first.
  // Fallbacks below match that set for local preview when the Liquid park is absent.
  // VetPay is not a Shopify type — Theme Editor image, or calm custom chip.

  function paymentMarkFromPark(id) {
    var park = document.querySelector('[data-baw-pay-park] [data-baw-pay-icon="' + id + '"]')
    if (!park) return ''
    var svg = park.querySelector('svg')
    if (!svg) return park.innerHTML || ''
    var clone = svg.cloneNode(true)
    clone.removeAttribute('width')
    clone.removeAttribute('height')
    clone.setAttribute('aria-hidden', 'true')
    clone.setAttribute('focusable', 'false')
    clone.classList.add('baw-review-pay-svg', 'baw-review-pay-svg--' + id)
    var titles = clone.querySelectorAll('title')
    for (var t = 0; t < titles.length; t++) titles[t].parentNode.removeChild(titles[t])
    clone.removeAttribute('aria-labelledby')
    clone.removeAttribute('role')
    return clone.outerHTML
  }

  function paymentMarkSvg(id, trust) {
    // VetPay: true vector paths (source VetPayIcon.svg embeds a PNG inside an SVG shell).
    if (id === 'vetPay') {
      return '<svg class="baw-review-pay-vetpay" viewBox="0 0 48 26" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="26" rx="3.5" fill="#5087C7"/><path fill="#fff" d="M7.96 17.2 4.99 8.91H6.81L8.91 15.04L10.94 8.91H12.72L9.75 17.2ZM17.04 15.29 18.62 15.55Q18.32 16.42 17.66 16.88Q17 17.34 16.01 17.34Q14.44 17.34 13.69 16.31Q13.1 15.49 13.1 14.24Q13.1 12.75 13.88 11.9Q14.66 11.06 15.85 11.06Q17.19 11.06 17.97 11.94Q18.74 12.83 18.71 14.65H14.73Q14.74 15.36 15.11 15.75Q15.48 16.15 16.03 16.15Q16.4 16.15 16.66 15.94Q16.91 15.74 17.04 15.29ZM17.13 13.68Q17.11 12.99 16.77 12.63Q16.44 12.27 15.95 12.27Q15.43 12.27 15.09 12.65Q14.75 13.03 14.75 13.68ZM22.76 11.19V12.46H21.67V14.88Q21.67 15.62 21.71 15.74Q21.74 15.86 21.85 15.94Q21.96 16.02 22.12 16.02Q22.34 16.02 22.76 15.86L22.89 17.1Q22.34 17.34 21.63 17.34Q21.2 17.34 20.86 17.19Q20.51 17.05 20.35 16.82Q20.19 16.59 20.13 16.2Q20.08 15.92 20.08 15.08V12.46H19.35V11.19H20.08V10L21.67 9.07V11.19Z"/><path fill="#fff" d="M23.93 17.2V8.91H27.06Q27.88 8.91 28.32 8.98Q28.93 9.09 29.34 9.37Q29.75 9.66 30.01 10.17Q30.26 10.69 30.26 11.3Q30.26 12.36 29.58 13.1Q28.91 13.83 27.15 13.83H25.02V17.2ZM25.02 12.85H27.17Q28.23 12.85 28.68 12.45Q29.13 12.06 29.13 11.34Q29.13 10.82 28.86 10.45Q28.6 10.08 28.17 9.96Q27.89 9.88 27.15 9.88H25.02ZM35.45 16.46Q34.88 16.94 34.36 17.14Q33.83 17.34 33.23 17.34Q32.24 17.34 31.71 16.85Q31.18 16.37 31.18 15.62Q31.18 15.17 31.38 14.81Q31.58 14.44 31.91 14.22Q32.23 14 32.64 13.89Q32.94 13.81 33.55 13.74Q34.78 13.59 35.36 13.39Q35.37 13.18 35.37 13.12Q35.37 12.5 35.08 12.24Q34.69 11.9 33.92 11.9Q33.2 11.9 32.86 12.15Q32.52 12.4 32.35 13.04L31.36 12.91Q31.49 12.27 31.8 11.87Q32.11 11.48 32.7 11.27Q33.29 11.06 34.07 11.06Q34.84 11.06 35.32 11.24Q35.8 11.42 36.02 11.69Q36.25 11.97 36.34 12.38Q36.39 12.65 36.39 13.32V14.68Q36.39 16.1 36.46 16.48Q36.52 16.85 36.71 17.2H35.65Q35.49 16.88 35.45 16.46ZM35.36 14.18Q34.81 14.41 33.7 14.57Q33.07 14.66 32.81 14.77Q32.55 14.89 32.41 15.1Q32.27 15.32 32.27 15.59Q32.27 15.99 32.57 16.27Q32.88 16.54 33.48 16.54Q34.07 16.54 34.52 16.28Q34.98 16.02 35.2 15.58Q35.36 15.23 35.36 14.56ZM37.92 19.51 37.81 18.56Q38.15 18.65 38.39 18.65Q38.73 18.65 38.94 18.54Q39.14 18.42 39.27 18.22Q39.37 18.07 39.58 17.46Q39.61 17.38 39.67 17.21L37.39 11.19H38.49L39.74 14.67Q39.98 15.33 40.18 16.06Q40.35 15.36 40.6 14.69L41.88 11.19H42.9L40.61 17.3Q40.24 18.29 40.04 18.67Q39.77 19.17 39.42 19.4Q39.07 19.64 38.58 19.64Q38.29 19.64 37.92 19.51Z"/></svg>'
    }
    var fromPark = paymentMarkFromPark(id)
    if (fromPark) return fromPark
    // Fallback when Liquid park is missing (local preview) — still recognizable, Shopify-sized 38×24.
    switch (id) {
      case 'shopPay':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#5A31F4"/><text x="19" y="15.5" text-anchor="middle" fill="#fff" font-size="8" font-family="Arial,Helvetica,sans-serif" font-weight="700">Shop Pay</text></svg>'
      case 'visa':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#1434CB"/><path fill="#fff" d="M16.2 15.8h-2.1l1.3-8h2.1l-1.3 8zm8.7-7.8c-.4-.2-1.1-.4-1.9-.4-2.1 0-3.6 1.1-3.6 2.7 0 1.2 1.1 1.8 1.9 2.2.9.4 1.2.7 1.2 1.1 0 .6-.7.8-1.3.8-.9 0-1.4-.1-2.1-.5l-.3-.1-.3 1.8c.5.2 1.5.4 2.5.4 2.3 0 3.7-1.1 3.8-2.8.01-1.4-1-2-1.9-2.4-.8-.4-1.2-.7-1.2-1.1 0-.4.4-.8 1.4-.8.8 0 1.3.2 1.8.4l.2.1.3-1.7zm5.5-.2h-1.6c-.5 0-.9.2-1 .7l-3 7.3h2.1l.4-1.2h2.6l.3 1.2h1.9l-1.7-8zm-2.5 5.2c.2-.5 1-2.8 1-2.8l.1-.2.5 2.9h-1.6v.1zM13.1 7.8l-2 8H9l-1-5.1c-.1-.3-.1-.5-.4-.6C7.1 9.9 6.3 9.6 5.6 9.4l0-.2h3.3c.4 0 .8.3.9.7l.8 4.4 2-5.1h2.1z"/></svg>'
      case 'mastercard':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#252525"/><circle cx="15" cy="12" r="7" fill="#EB001B"/><circle cx="23" cy="12" r="7" fill="#F79E1B"/><path d="M19 6.8a7 7 0 0 1 0 10.4 7 7 0 0 1 0-10.4z" fill="#FF5F00"/></svg>'
      case 'amex':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#1F72CD"/><text x="19" y="15.5" text-anchor="middle" fill="#fff" font-size="7" font-family="Arial,Helvetica,sans-serif" font-weight="700" letter-spacing=".04em">AMEX</text></svg>'
      case 'applePay':
        /* White fill only — CSS .baw-review-pay-mark--applePay supplies the
           quiet #d2c9bb hairline (no black SVG frame). */
        return '<svg class="baw-review-pay-svg baw-review-pay-svg--applePay" viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#fff"/><text x="19" y="15.5" text-anchor="middle" fill="#000" font-size="7" font-family="Arial,Helvetica,sans-serif" font-weight="600">Pay</text></svg>'
      case 'googlePay':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect x=".5" y=".5" width="37" height="23" rx="3" fill="#fff" stroke="#e4dcce"/><text x="19" y="15.5" text-anchor="middle" fill="#3c4043" font-size="7" font-family="Arial,Helvetica,sans-serif" font-weight="700">GPay</text></svg>'
      case 'paypal':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect x=".5" y=".5" width="37" height="23" rx="3" fill="#fff" stroke="#e4dcce"/><text x="19" y="15.5" text-anchor="middle" fill="#003087" font-size="8" font-family="Arial,Helvetica,sans-serif" font-weight="700">PayPal</text></svg>'
      case 'afterpay':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#b2fce4"/><text x="19" y="15.5" text-anchor="middle" fill="#000" font-size="6.5" font-family="Arial,Helvetica,sans-serif" font-weight="700">afterpay</text></svg>'
      case 'zip':
        return '<svg viewBox="0 0 38 24" aria-hidden="true"><rect width="38" height="24" rx="3" fill="#1A1446"/><text x="19" y="15.5" text-anchor="middle" fill="#fff" font-size="9" font-family="Arial,Helvetica,sans-serif" font-weight="700">zip</text></svg>'
      default:
        return ''
    }
  }

  function renderReviewPaymentsHtml(config) {
    var trust = reviewTrustConfig(config)
    var flags = trust.payments || {}
    var methods = trust.showPayments === false
      ? []
      : [
          { id: 'visa', label: 'Visa', on: !!flags.visa },
          { id: 'mastercard', label: 'Mastercard', on: !!flags.mastercard },
          { id: 'amex', label: 'American Express', on: !!flags.amex },
          { id: 'applePay', label: 'Apple Pay', on: !!flags.applePay },
          { id: 'googlePay', label: 'Google Pay', on: !!flags.googlePay },
          { id: 'shopPay', label: 'Shop Pay', on: !!flags.shopPay },
          { id: 'paypal', label: 'PayPal', on: !!flags.paypal },
          { id: 'afterpay', label: 'Afterpay', on: !!flags.afterpay },
          { id: 'zip', label: 'Zip', on: !!flags.zip },
          { id: 'vetPay', label: 'VetPay', on: !!flags.vetPay },
        ].filter(function (m) { return m.on })
    var marks = methods.map(function (m) {
      return (
        '<li class="baw-review-pay-item" title="' + escapeHtml(m.label) + '">' +
        '<span class="baw-review-pay-mark baw-review-pay-mark--' + m.id + '" aria-label="' + escapeHtml(m.label) + '">' +
        paymentMarkSvg(m.id, trust) +
        '</span></li>'
      )
    }).join('')
    if (!marks) return ''
    return (
      '<div class="baw-review-payments">' +
      '<ul class="baw-review-pay-list" role="list">' + marks + '</ul>' +
      '</div>'
    )
  }

  /**
   * Both flows go straight to checkout so families are not sent to the cart
   * page for a second click.
   */
  function reviewPrimaryCta() {
    return {
      label: 'Continue to checkout',
      url: '/checkout',
    }
  }

  /** Notes + shared ack (callouts) above Total; trust/payments below Continue on desktop. */
  function renderReviewCheckoutPanelHtml(total, config, state, opts) {
    opts = opts || {}
    var calloutsHtml = opts.calloutsHtml || ''
    var footerGuidanceHtml = opts.footerGuidanceHtml || ''
    var trustHtml = renderReviewTrustHtml(config)
    var payHtml = renderReviewPaymentsHtml(config)
    var totalLabel = formatMoney(total, config && config.moneyFormat)
    var shopUrl = config && config.reviewShopLinkEnabled && config.reviewShopLinkUrl
    var shopLabel = (config && config.reviewShopLinkLabel) || 'Memorial Store'
    var primaryCta = reviewPrimaryCta(config)
    var shopBtn = shopUrl
      ? '<button type="button" class="baw-review-shop" data-baw-review-shop>' + escapeHtml(shopLabel) + '</button>'
      : ''
    return (
      '<aside class="baw-review-checkout" aria-label="Checkout summary">' +
      calloutsHtml +
      footerGuidanceHtml +
      '<div class="baw-review-total"><span class="baw-review-total-label">Total</span><span class="baw-review-total-value">' + totalLabel + '</span></div>' +
      '<div id="baw-submit-error" class="baw-error" style="display:none"></div>' +
      '<div class="baw-actions baw-review-actions">' +
      '<button type="button" class="baw-continue baw-continue--review" data-baw-continue data-baw-continue-action="submit">' + escapeHtml(primaryCta.label) + '</button>' +
      shopBtn +
      '</div>' +
      trustHtml +
      payHtml +
      '</aside>'
    )
  }

  function isNoKeepsakeLabel(label) {
    var s = String(label || '').toLowerCase()
    return !s || /\bno\b/.test(s) && /keepsake|thanks|required|not/.test(s) || /^not\b/.test(s) || s === 'none'
  }

  function isTangibleMemorialItem(item) {
    if (!item || String(item.id || '').indexOf('memorial:') !== 0) return false
    if (String(item.id).indexOf(':addon:') !== -1) return false
    if (item.included) return true
    if (!item.variantId && isNoKeepsakeLabel(item.valueLabel)) return false
    return !!(item.variantId || item.included)
  }

  function buildMemorialGalleryItems(items, state, config) {
    var memorialLines = []
    ;(items || []).forEach(function (item) {
      if (String(item.id || '').indexOf('memorial:') !== 0) return
      if (item.isPlacement || String(item.id || '').indexOf(':ashes-placement') !== -1) return
      memorialLines.push(item)
    })
    return collapseMemorialsForSummary(
      orderMemorialLinesForSummary(memorialLines),
      getMemorialCatalog(state, config),
      state
    ).map(function (line) {
      return {
        id: line.id,
        title: line.valueLabel || line.groupLabel || 'Memorial',
        colour: String(line.variantMeta || '').trim(),
        image: line.image ? String(line.image) : '',
        price: line.included ? 0 : (Number(line.price) || 0),
        variantId: line.variantId,
        productId: line.productId != null ? line.productId : null,
        memorialGroupKey: line.memorialGroupKey || '',
        editStepId: line.editStepId,
        included: !!line.included,
        metaLines: line.metaLines || [],
        reviewBlankCardImage: line.reviewBlankCardImage || '',
        personaliseImage: line.personaliseImage || '',
        needsPhoto: !!line.needsPhoto,
      }
    })
  }

  function buildReviewDetailGroups(items, state, config) {
    var reviewItems = buildReviewItems(items, state)
    var byId = {}
    reviewItems.forEach(function (i) { byId[i.id] = i })

    var groups = []

    // CREMATION — compact value row (no tall label-per-field)
    if (byId.cremation) {
      var cremationDisplay = reviewRowDisplay(byId.cremation, state, config)
      groups.push({
        id: 'cremation',
        title: 'Cremation',
        editStepId: byId.cremation.editStepId,
        lines: [{
          label: '',
          value: cremationDisplay.valueLabel,
          price: byId.cremation.price,
          variantId: byId.cremation.variantId,
          hint: '',
        }],
      })
    }

    // CARE ARRANGEMENTS — values only; meaning comes from compact summary lines
    var careIds = [
      'transport-main', 'transport-sub', 'transport-location',
      'transport-date', 'transport-time', 'transport-vet', 'transport-address',
    ]
    var careLines = []
    careIds.forEach(function (id) {
      var item = byId[id]
      if (!item) return
      var display = reviewRowDisplay(item, state, config)
      var value = display.valueLabel || ''
      // Prefer value; fall back to former group label only when value empty
      if (!value && display.groupLabel) value = display.groupLabel
      careLines.push({
        id: item.id,
        label: '',
        value: value,
        hint: display.valueHint || '',
        price: item.price,
        variantId: item.variantId,
        clinic: item.id === 'transport-vet',
      })
    })
    if (careLines.length) {
      var careEdit =
        (byId['transport-main'] && byId['transport-main'].editStepId) ||
        (byId['transport-sub'] && byId['transport-sub'].editStepId) ||
        'transport-category'
      var arrivalPath = !!(state && isLonsdaleTransport(state))
      groups.push({
        id: 'care',
        title: arrivalPath ? 'Arrival' : 'Care arrangements',
        editStepId: careEdit,
        lines: careLines,
      })
    }

    // Memorials — one tally line so the rail adds up to Total. Cards stay on the left.
    var memorialPrice = 0
    ;(items || []).forEach(function (item) {
      if (!item) return
      var id = String(item.id || '')
      if (id.indexOf('memorial:') !== 0) return
      if (item.isPlacement || id.indexOf(':ashes-placement') !== -1) return
      memorialPrice += Number(item.price) || 0
    })
    var memorialGallery = buildMemorialGalleryItems(items, state, config)
    if (memorialGallery.length) {
      groups.push({
        id: 'memorials',
        title: 'Memorials',
        editStepId: memorialGallery[0].editStepId || null,
        lines: [{
          label: '',
          value: memorialGallery.length === 1 ? '1 item' : memorialGallery.length + ' items',
          price: memorialPrice,
          included: memorialPrice <= 0,
          hint: '',
        }],
      })
    }

    // MEMORIALS — visual gallery on Review (not itemized pricing cards).
    var reviewPlacementLines = []
    var urnEntry = state && state.memorials && state.memorials.urn
    if (
      urnEntry &&
      typeof AngelAshesBookingMemorials !== 'undefined' &&
      AngelAshesBookingMemorials.ashesArrangementReviewLines
    ) {
      AngelAshesBookingMemorials.syncAshesPlacement(urnEntry, null, state)
      reviewPlacementLines = AngelAshesBookingMemorials.ashesArrangementReviewLines(
        urnEntry,
        null,
        state
      ) || []
    }
    if (!reviewPlacementLines.length) {
      var summaryPlacement = ashesPlacementSummaryLines
        ? ashesPlacementSummaryLines(state)
        : (ashesPlacementSummaryLine ? [ashesPlacementSummaryLine(state)].filter(Boolean) : [])
      reviewPlacementLines = summaryPlacement.map(function (line) {
        return line && line.valueLabel
      }).filter(Boolean)
    }
    if (reviewPlacementLines.length) {
      groups.push({
        id: 'ashes-placement',
        title: 'Ashes placement',
        editStepId: 'memorial:urn',
        lines: reviewPlacementLines.map(function (text, idx) {
          return {
            id: 'memorial:urn:ashes-placement' + (idx ? ':' + idx : ''),
            label: '',
            value: text,
            hint: '',
            price: null,
            hidePrice: true,
            isPlacement: true,
            editStepId: 'memorial:urn',
          }
        }),
      })
    }

    // ASHES RETURN — speed + method without Timing/Return field labels
    var ashesLines = []
    if (byId['return-speed']) {
      var rsDisplay = reviewRowDisplay(byId['return-speed'], state, config)
      ashesLines.push({
        label: '',
        value: rsDisplay.valueLabel,
        hint: '',
        price: byId['return-speed'].price,
        variantId: byId['return-speed'].variantId,
      })
    }
    if (byId['return-method']) {
      var methodPrice = byId['return-method'].price
      ashesLines.push({
        label: '',
        value: returnSummaryLabel(state) || byId['return-method'].valueLabel,
        hint: '',
        price: methodPrice,
        variantId: byId['return-method'].variantId,
        hidePrice: !methodPrice,
      })
    }
    if (ashesLines.length) {
      groups.push({
        id: 'ashes-return',
        title: memorialReturnSectionTitle(state, config),
        editStepId: (byId['return-speed'] && byId['return-speed'].editStepId) ||
          (byId['return-method'] && byId['return-method'].editStepId) ||
          'return-speed',
        lines: ashesLines,
      })
    }

    return groups
  }

  /**
   * Cart lines for /cart/add.js.
   *
   * - Cremation line: pet properties only (name / breed / weight). Core parent.
   * - Collection, arrival, return, and service speed nest under that
   *   cremation line (`parent_id` / `parent_line_key`) on individual and shared.
   * - Memorials, paw prints, photos, nameplates, and engraving stay peer
   *   lines. Nesting those is how a print disappears before checkout.
   * - Date / time / clinic / address stay properties on the transport line
   *   via attachPropertiesToLineId — not extra SKUs.
   *
   * Line properties that start with `_` are hidden at checkout; Shopify admin
   * still lists them (and always expands that row — we cannot collapse it).
   * Write `_Booking_Line` on the cremation parent, and when the same variant
   * appears twice (photo-print / nameplate SKUs).
   */

  function cremationServiceChild(line) {
    return !!(line && String(line.nestedUnder || '') === 'cremation')
  }

  function buildCartLines(items) {
    var extraProps = {}
    var serviceParentIds = {}
    var variantCounts = {}
    items.forEach(function (i) {
      var attachTargets = []
      if (i.attachPropertiesToLineId) attachTargets.push(i.attachPropertiesToLineId)
      if (i.attachPropertiesAlsoToLineId) {
        var alsoAttach = i.attachPropertiesAlsoToLineId
        if (Array.isArray(alsoAttach)) {
          alsoAttach.forEach(function (targetId) {
            if (targetId) attachTargets.push(targetId)
          })
        } else {
          attachTargets.push(alsoAttach)
        }
      }
      attachTargets.forEach(function (copyTo) {
        if (copyTo && i.properties) {
          extraProps[copyTo] = Object.assign({}, extraProps[copyTo], i.properties)
        }
      })
      var copyTo = i.mirrorPropertiesToLineId || i.attachPropertiesToLineId
      if (copyTo && i.properties && i.mirrorPropertiesToLineId) {
        extraProps[copyTo] = Object.assign({}, extraProps[copyTo], i.properties)
      }
      if (cremationServiceChild(i)) serviceParentIds[String(i.nestedUnder)] = true
      if (i.variantId != null && i.variantId !== '') {
        var vid = String(i.variantId)
        variantCounts[vid] = (variantCounts[vid] || 0) + 1
      }
    })

    return items
      .filter(function (i) {
        var id = Number(i.variantId)
        return i.variantId != null && i.variantId !== '' && isFinite(id) && id > 0
      })
      .map(function (i) {
        // attach-only (no fee SKU) moves props onto the parent. mirror keeps
        // them on this line as well so the fee still carries the print URLs.
        var forwardedAway = !!i.attachPropertiesToLineId && !i.mirrorPropertiesToLineId
        var props = normalizeCartLineProperties(Object.assign(
          {},
          forwardedAway ? {} : (i.properties || {}),
          extraProps[i.id] || {}
        ))
        var line = {
          id: Number(i.variantId),
          quantity: memorialOrderQuantity(i),
        }
        var duplicateSku = i.variantId != null && variantCounts[String(i.variantId)] > 1
        if (i.id && (serviceParentIds[String(i.id)] || duplicateSku)) {
          props[cartLinePropertyKey('Booking Line', true)] = String(i.id)
        }
        if (cremationServiceChild(i)) {
          props[cartLinePropertyKey('Booking Parent', true)] = 'cremation'
          line.cremationService = true
        }
        if (String(i.id) === 'cremation') line.cremationLead = true
        // Hidden marker so a later booking can replace these lines without
        // clearing jewellery or other products already in the cart.
        props[cartLinePropertyKey('Booking', true)] = '1'
        if (Object.keys(props).length) line.properties = props
        return line
      })
  }

  /**
   * Shopify /cart/add.js is atomic: one unavailable or duplicate-in-request
   * variant 422s the whole payload. Photo Tribute + Ink Photo Set share the
   * same photo-print fee SKU *and* the same Gold/Silver nameplate SKU, each
   * with different properties — those must go in separate POSTs.
   *
   * Checkout lists the most recently added line first. Memorials are posted
   * first. Cremation, then its collection / return / service-speed lines, are
   * posted last so the cremation product is the first line in the cart.
   */
  function partitionVariantBatches(lines) {
    var remaining = Array.isArray(lines) ? lines.slice() : []
    var batches = []
    while (remaining.length) {
      var batch = []
      var seen = {}
      var next = []
      remaining.forEach(function (line) {
        if (!line || line.id == null) return
        var id = String(line.id)
        if (seen[id]) {
          next.push(line)
          return
        }
        seen[id] = true
        batch.push(line)
      })
      if (!batch.length) break
      batches.push(batch)
      remaining = next
    }
    return batches
  }

  function partitionCartAddBatches(lines) {
    var peers = []
    var cremation = []
    var services = []
    ;(lines || []).forEach(function (line) {
      if (!line) return
      if (line.cremationLead) cremation.push(line)
      else if (line.cremationService || cartLineParentBookingId(line) === 'cremation') services.push(line)
      else peers.push(line)
    })
    return partitionVariantBatches(peers).concat(partitionVariantBatches(cremation.concat(services)))
  }

  function readCartLineProperty(props, name) {
    if (!props) return ''
    var want = String(name || '')
      .replace(/^_+/, '')
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase()
    if (!want) return ''
    function matches(key) {
      return String(key || '')
        .replace(/^_+/, '')
        .replace(/_/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase() === want
    }
    if (Array.isArray(props)) {
      for (var i = 0; i < props.length; i++) {
        if (!matches(props[i] && props[i].name)) continue
        return String(props[i].value || '').trim()
      }
      return ''
    }
    var keys = Object.keys(props)
    for (var j = 0; j < keys.length; j++) {
      if (matches(keys[j])) return String(props[keys[j]] || '').trim()
    }
    return ''
  }

  function cartLineBookingId(line) {
    return readCartLineProperty(line && line.properties, 'Booking Line')
  }

  function cartLineParentBookingId(line) {
    return readCartLineProperty(line && line.properties, 'Booking Parent')
  }

  /** Lines this wizard added. Shop products without these properties stay in the cart. */
  function isPreviousBookingCartLine(item) {
    if (!item) return false
    var props = item.properties
    if (readCartLineProperty(props, 'Booking')) return true
    if (readCartLineProperty(props, 'Booking Line')) return true
    if (readCartLineProperty(props, 'Booking Parent')) return true
    if (readCartLineProperty(props, 'Pet Name')) return true
    if (readCartLineProperty(props, 'Collection Type')) return true
    return false
  }

  /** `{ lineKey: 0 }` for /cart/update.js — previous booking lines only. */
  function previousBookingCartUpdates(items) {
    var bookingKeys = {}
    ;(items || []).forEach(function (item) {
      if (!item || !item.key || !isPreviousBookingCartLine(item)) return
      bookingKeys[String(item.key)] = true
    })
    ;(items || []).forEach(function (item) {
      if (!item || !item.key) return
      var parentKey = item.parent_relationship && item.parent_relationship.parent_key
      if (parentKey && bookingKeys[String(parentKey)]) bookingKeys[String(item.key)] = true
    })
    var updates = {}
    Object.keys(bookingKeys).forEach(function (key) {
      updates[key] = 0
    })
    return updates
  }

  function indexCartLineKeys(addedItems, knownKeys) {
    var out = knownKeys || {}
    ;(addedItems || []).forEach(function (item) {
      if (!item || !item.key) return
      var bookingId = readCartLineProperty(item.properties, 'Booking Line')
      if (bookingId) out[bookingId] = String(item.key)
    })
    return out
  }

  /**
   * Nest collection / return / service speed under the cremation variant.
   * Same-batch children use `parent_id`. A later batch uses `parent_line_key`.
   * Memorial lines never receive a parent ref.
   */
  function attachCartLineParentRefs(batch, knownKeys) {
    var bookingToVariant = {}
    ;(batch || []).forEach(function (line) {
      var bid = cartLineBookingId(line)
      if (bid && line && line.id != null) bookingToVariant[bid] = Number(line.id)
    })
    return (batch || []).map(function (line) {
      if (!line) return line
      var copy = Object.assign({}, line)
      delete copy.parent_id
      delete copy.parent_line_key
      if (cartLineParentBookingId(line) !== 'cremation') return copy
      var parentVariantInBatch = bookingToVariant.cremation
      if (parentVariantInBatch) {
        copy.parent_id = parentVariantInBatch
        return copy
      }
      var parentKey = knownKeys && knownKeys.cremation
      if (parentKey) copy.parent_line_key = parentKey
      return copy
    })
  }

  function cartAddPayloadItems(batch) {
    return (batch || []).map(function (line) {
      var out = {
        id: line.id,
        quantity: line.quantity || 1,
      }
      if (line.properties) out.properties = line.properties
      if (line.parent_id != null) out.parent_id = Number(line.parent_id)
      if (line.parent_line_key) out.parent_line_key = String(line.parent_line_key)
      return out
    })
  }

  function ledgerLineHasVariant(line) {
    var id = Number(line && line.variantId)
    return !!(line && line.variantId != null && line.variantId !== '' && isFinite(id) && id > 0)
  }

  /**
   * A review row the family accepted must have a variant before we leave
   * for the cart. Declined add-ons and included plates (text copied onto
   * the memorial) are not separate products.
   */
  function reviewLinesMissingVariant(items) {
    var missing = []
    ;(items || []).forEach(function (line) {
      if (!line || ledgerLineHasVariant(line) || line.included || line.hidePrice) return
      var addon = String(line.id || '').indexOf(':addon:') !== -1
      var priced = Number(line.price) > 0
      if (addon || priced) missing.push(line)
    })
    return missing
  }

  function cartAddReturnedItems(body) {
    if (!body) return []
    if (Array.isArray(body.items)) return body.items
    if (body.variant_id != null || body.id != null) return [body]
    return []
  }

  /**
   * /cart/add.js can return HTTP 200 with an empty items list when a nested
   * child is rejected. Treat that as a failure so we never open checkout
   * with a print missing.
   */
  function cartAddCoversPostedLines(posted, body) {
    var lines = posted || []
    if (!lines.length) return true
    var need = {}
    lines.forEach(function (line) {
      if (!line || line.id == null) return
      var id = String(line.id)
      need[id] = (need[id] || 0) + (Number(line.quantity) || 1)
    })
    var got = {}
    cartAddReturnedItems(body).forEach(function (item) {
      if (!item) return
      var id = item.variant_id != null ? String(item.variant_id) : String(item.id)
      got[id] = (got[id] || 0) + (Number(item.quantity) || 0)
    })
    return Object.keys(need).every(function (id) {
      return (got[id] || 0) >= need[id]
    })
  }

  function cartBatchHasParentRefs(items) {
    return (items || []).some(function (item) {
      return item && (item.parent_id != null || item.parent_line_key)
    })
  }

  function normalizeCartAttributes(attrs) {
    if (!attrs || typeof attrs !== 'object') return {}
    var out = {}
    Object.keys(attrs).forEach(function (key) {
      var name = String(key || '').trim()
      if (!name) return
      var val = attrs[key]
      if (val == null) return
      var str = String(val).trim()
      if (!str) return
      if (str.length > CART_LINE_PROPERTY_VALUE_MAX) {
        str = str.slice(0, CART_LINE_PROPERTY_VALUE_MAX)
      }
      out[name] = str
    })
    return out
  }

  function buildCartAttributes(state) {
    // Additional details is order-level only. Date / time / clinic / address /
    // collection type live on the transport line; return path is the SKU.
    // Do not `_`-prefix these — private *attributes* use `__`, and a single `_`
    // plus a space can 422 /cart/update.js.
    var attrs = {}
    if (state.returnMethod.location) {
      attrs['Choose a Convenient Pick-Up Location'] = state.returnMethod.location
    }

    var instructions = specialInstructionsText(state)
    if (instructions) attrs['Special instructions'] = instructions

    var ashesPlacement =
      typeof urnAshesPlacementDisplayValue === 'function'
        ? urnAshesPlacementDisplayValue(state)
        : ''
    if (ashesPlacement) attrs['Ashes placement'] = ashesPlacement

    Object.keys(attrs).forEach(function (key) {
      if (attrs[key] == null || String(attrs[key]).trim() === '') delete attrs[key]
    })

    return normalizeCartAttributes(attrs)
  }

  /* ------------------------------ wizard ----------------------------------- */

    return {
      petProperties: petProperties,
      cremationGroupLabel: cremationGroupLabel,
      bookingRailTitle: bookingRailTitle,
      sentenceCase: sentenceCase,
      transportNoteLabel: transportNoteLabel,
      transportCategoryShort: transportCategoryShort,
      compactServiceLevel: compactServiceLevel,
      transportSummaryLabel: transportSummaryLabel,
      buildLedger: buildLedger,
      buildSummarySections: buildSummarySections,
      transportNoteLabelForReturn: transportNoteLabelForReturn,
      returnSpeedDayBounds: returnSpeedDayBounds,
      ashesReadyEstimateRangeForState: ashesReadyEstimateRangeForState,
      ashesReadyEstimateRangeLabel: ashesReadyEstimateRangeLabel,
      ashesReturnFooterNotesHtml: ashesReturnFooterNotesHtml,
      cremationSummaryLabel: cremationSummaryLabel,
      petWeightSummaryLabel: petWeightSummaryLabel,
      cremationRailValueLabel: cremationRailValueLabel,
      returnSpeedSummaryLabel: returnSpeedSummaryLabel,
      returnSpeedReviewLabel: returnSpeedReviewLabel,
      memorialReviewGroupLabel: memorialReviewGroupLabel,
      reviewRowDisplay: reviewRowDisplay,
      buildReviewItems: buildReviewItems,
      returnSpeedTileDesc: returnSpeedTileDesc,
      returnSummaryLabel: returnSummaryLabel,
      isPaidMemorialDelivery: isPaidMemorialDelivery,
      memorialReturnSectionTitle: memorialReturnSectionTitle,
      ledgerTotal: ledgerTotal,
      reviewTrustConfig: reviewTrustConfig,
      renderReviewTrustHtml: renderReviewTrustHtml,
      paymentMarkFromPark: paymentMarkFromPark,
      paymentMarkSvg: paymentMarkSvg,
      renderReviewPaymentsHtml: renderReviewPaymentsHtml,
      renderReviewNotesHtml: renderReviewNotesHtml,
      renderReviewCalloutsHtml: renderReviewCalloutsHtml,
      reviewPrimaryCta: reviewPrimaryCta,
      renderReviewCheckoutPanelHtml: renderReviewCheckoutPanelHtml,
      isNoKeepsakeLabel: isNoKeepsakeLabel,
      isTangibleMemorialItem: isTangibleMemorialItem,
      collapseMemorialsForSummary: collapseMemorialsForSummary,
      buildMemorialGalleryItems: buildMemorialGalleryItems,
      buildReviewDetailGroups: buildReviewDetailGroups,
      buildCartLines: buildCartLines,
      buildCartAttributes: buildCartAttributes,
      partitionCartAddBatches: partitionCartAddBatches,
      attachCartLineParentRefs: attachCartLineParentRefs,
      reviewLinesMissingVariant: reviewLinesMissingVariant,
      cartAddCoversPostedLines: cartAddCoversPostedLines,
      cartAddPayloadItems: cartAddPayloadItems,
      indexCartLineKeys: indexCartLineKeys,
      cartLineBookingId: cartLineBookingId,
      cartLineParentBookingId: cartLineParentBookingId,
      previousBookingCartUpdates: previousBookingCartUpdates,
      cartBatchHasParentRefs: cartBatchHasParentRefs,
      normalizeCartAttributes: normalizeCartAttributes,
      cartLinePropertyKey: cartLinePropertyKey,
      compactCartImageUrl: compactCartImageUrl,
      normalizeCartLineProperties: normalizeCartLineProperties,
      sellableVariantId: sellableVariantId,
      feeCartVariantId: feeCartVariantId,
      addonVariantPrice: addonVariantPrice,
      isSellableCartVariant: isSellableCartVariant,
      inventoryAllowsSale: inventoryAllowsSale,
      engravingForDisplay: engravingForDisplay,
      specialInstructionsText: specialInstructionsText,
      specialInstructionsOpen: specialInstructionsOpen,
      specialInstructionsStoredText: specialInstructionsStoredText,
      SPECIAL_INSTRUCTIONS_MAX: SPECIAL_INSTRUCTIONS_MAX,
      variantIdOf: variantIdOf,
      findVariantById: findVariantById,
      serializeBookingDraft: serializeBookingDraft,
      clearBookingDraft: clearBookingDraft,
      saveBookingDraft: saveBookingDraft,
      readBookingDraftRaw: readBookingDraftRaw,
      restoreBookingDraft: restoreBookingDraft,
      bookingDraftStorageKey: bookingDraftStorageKey,
      BOOKING_DRAFT_KEY_LEGACY: BOOKING_DRAFT_KEY_LEGACY
    }
  }

  var INSTALL_SRC = `    function closePhotoPreviewModal() {
      var modal = root.querySelector('[data-baw-photo-preview-modal]')
      if (modal) modal.parentNode.removeChild(modal)
      root.classList.remove('has-photo-preview-modal')
    }

    function bindPreviewModalChrome(wrap, onClose) {
      var closeBtns = wrap.querySelectorAll('[data-baw-photo-preview-close]')
      closeBtns.forEach(function (btn) { btn.addEventListener('click', onClose) })
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault()
          onClose()
        }
      })
      var closeBtn = wrap.querySelector('.baw-photo-preview-modal-close')
      if (closeBtn) {
        try { closeBtn.focus({ preventScroll: true }) } catch (err) { closeBtn.focus() }
      }
    }

    /**
     * Real hand-engraving reference photo (Theme Editor). Never overlays customer text.
     * Returns focus to the example link after close.
     */

    function openEngravingExampleModal(visuals, returnFocusSel) {
      var imageUrl = visuals && visuals.imageUrl ? String(visuals.imageUrl).trim() : ''
      if (!imageUrl) return
      var caption = visuals.caption != null ? String(visuals.caption).trim() : ''
      var focusSel = returnFocusSel || '[data-engraving-example-link]'
      closePhotoPreviewModal()
      root.classList.add('has-photo-preview-modal')
      var wrap = document.createElement('div')
      wrap.className = 'baw-photo-preview-modal baw-photo-preview-modal--engraving'
      wrap.setAttribute('data-baw-photo-preview-modal', '1')
      wrap.setAttribute('role', 'dialog')
      wrap.setAttribute('aria-modal', 'true')
      wrap.setAttribute('aria-label', 'Engraving example')
      wrap.innerHTML =
        '<div class="baw-photo-preview-modal-backdrop" data-baw-photo-preview-close tabindex="-1"></div>' +
        '<div class="baw-photo-preview-modal-panel baw-photo-preview-modal-panel--engraving">' +
        '<button type="button" class="baw-photo-preview-modal-close" data-baw-photo-preview-close aria-label="Close example">' +
        '<span aria-hidden="true">&times;</span></button>' +
        '<div class="baw-photo-preview-modal-body">' +
        '<img class="baw-photo-preview-modal-img" src="' + escapeHtml(imageUrl) + '"' +
        ' alt="' + escapeHtml(caption || 'Example of hand engraving') + '" />' +
        (caption
          ? '<p class="baw-field-hint baw-engraving-example-caption">' + escapeHtml(caption) + '</p>'
          : '') +
        '</div></div>'
      root.appendChild(wrap)
      bindPreviewModalChrome(wrap, function () {
        closePhotoPreviewModal()
        var link = els.step && els.step.querySelector(focusSel)
        if (!link) link = root.querySelector(focusSel)
        if (link) {
          try { link.focus({ preventScroll: true }) } catch (err) {
            try { link.focus() } catch (err2) { /* ignore */ }
          }
        }
      })
    }

    function openProductImagePreviewModal(url, alt) {
      if (!url) return
      closePhotoPreviewModal()
      root.classList.add('has-photo-preview-modal')
      var wrap = document.createElement('div')
      wrap.className = 'baw-photo-preview-modal baw-photo-preview-modal--product'
      wrap.setAttribute('data-baw-photo-preview-modal', '1')
      wrap.setAttribute('role', 'dialog')
      wrap.setAttribute('aria-modal', 'true')
      wrap.setAttribute('aria-label', alt || 'Product preview')
      // Cap product eye-preview — Satin Pouch master is 1800px / 1.5MB PNG.
      var previewPx =
        (typeof AngelAshesBookingMemorials !== 'undefined' &&
          AngelAshesBookingMemorials.MEMORIAL_ARTBOARD_PX) ||
        800
      var src = typeof sizedShopifyImageUrl === 'function'
        ? sizedShopifyImageUrl(url, previewPx)
        : url
      wrap.innerHTML =
        '<div class="baw-photo-preview-modal-backdrop" data-baw-photo-preview-close tabindex="-1"></div>' +
        '<div class="baw-photo-preview-modal-panel baw-photo-preview-modal-panel--product">' +
        '<button type="button" class="baw-photo-preview-modal-close" data-baw-photo-preview-close aria-label="Close preview">' +
        '<span aria-hidden="true">&times;</span></button>' +
        '<div class="baw-photo-preview-modal-body">' +
        '<img class="baw-photo-preview-modal-img" src="' + escapeHtml(src) + '"' +
        ' alt="' + escapeHtml(alt || 'Product preview') + '" />' +
        '</div></div>'
      root.appendChild(wrap)
      bindPreviewModalChrome(wrap, closePhotoPreviewModal)
    }

    function openPhotoPreviewModal(url, orientation, frameUrl) {
      if (!url) return
      closePhotoPreviewModal()
      root.classList.add('has-photo-preview-modal')
      var orient = orientation === 'portrait' ? 'portrait' : 'landscape'
      var mockup = String(frameUrl || '').trim()
      var wrap = document.createElement('div')
      wrap.className = 'baw-photo-preview-modal'
      wrap.setAttribute('data-baw-photo-preview-modal', '1')
      wrap.setAttribute('role', 'dialog')
      wrap.setAttribute('aria-modal', 'true')
      wrap.setAttribute('aria-label', 'Uploaded photo preview')
      wrap.setAttribute('data-orientation', orient)
      wrap.innerHTML =
        '<div class="baw-photo-preview-modal-backdrop" data-baw-photo-preview-close tabindex="-1"></div>' +
        '<div class="baw-photo-preview-modal-panel baw-photo-preview-modal-panel--photo' +
        (mockup ? ' baw-photo-preview-modal-panel--mockup' : '') +
        ' is-' + orient + '">' +
        '<button type="button" class="baw-photo-preview-modal-close" data-baw-photo-preview-close aria-label="Close preview">' +
        '<span aria-hidden="true">&times;</span></button>' +
        '<div class="baw-photo-preview-modal-body">' +
        renderPhotoPrintPreview(url, orient, mockup ? { frameUrl: mockup } : {}) +
        '</div></div>'
      root.appendChild(wrap)
      bindPreviewModalChrome(wrap, closePhotoPreviewModal)
      wirePhotoPreviewDecodeIn(wrap)
    }

    function openEngravingTextPreviewModal(groupKey, productId) {
      if (!groupKey) return
      var entry = getMemorialEntry(state, groupKey)
      var pid = resolveMemorialAddonProductId(state, config, groupKey, 'engraving', productId)
      focusMemorialAddonProduct(entry, pid)
      var engraving = entry && entry.addons && entry.addons.engraving
      if (!engraving || !engraving.choiceId || String(engraving.choiceId) === 'no') return
      var engLines = normalizeNameplateLines(engraving.lines)
      // Preview-only Lavanderia script — no Print/Script picker on engraving.
      var fontDef = nameplateFontDef('lavanderia')
      var line1 = String(engraving.text || '').trim()
      var line2 = engLines === 2 ? String(engraving.textLine2 || '').trim() : ''
      if (!line1 && !line2) return

      var linesHtml = ''
      if (line1) {
        linesHtml +=
          '<p class="baw-engraving-text-preview__line baw-engraving-text-preview__line--name baw-font-' +
          fontDef.id + '" style="font-family: ' + fontDef.cssFamily + ';">' +
          escapeHtml(line1) +
          '</p>'
      }
      if (line2) {
        linesHtml +=
          '<p class="baw-engraving-text-preview__line baw-font-' + fontDef.id +
          '" style="font-family: ' + fontDef.cssFamily + ';">' +
          escapeHtml(line2) +
          '</p>'
      }

      closePhotoPreviewModal()
      root.classList.add('has-photo-preview-modal')
      var wrap = document.createElement('div')
      wrap.className = 'baw-photo-preview-modal baw-photo-preview-modal--engraving-text'
      wrap.setAttribute('data-baw-photo-preview-modal', '1')
      wrap.setAttribute('role', 'dialog')
      wrap.setAttribute('aria-modal', 'true')
      wrap.setAttribute('aria-label', 'Engraving text preview')
      wrap.innerHTML =
        '<div class="baw-photo-preview-modal-backdrop" data-baw-photo-preview-close tabindex="-1"></div>' +
        '<div class="baw-photo-preview-modal-panel baw-photo-preview-modal-panel--engraving-text">' +
        '<button type="button" class="baw-photo-preview-modal-close" data-baw-photo-preview-close aria-label="Close preview">' +
        '<span aria-hidden="true">&times;</span></button>' +
        '<div class="baw-photo-preview-modal-body">' +
        '<div class="baw-engraving-text-preview">' +
        '<p class="baw-engraving-text-preview__eyebrow">Engraving</p>' +
        linesHtml +
        '</div></div></div>'
      root.appendChild(wrap)
      bindPreviewModalChrome(wrap, closePhotoPreviewModal)
    }

    function engravingPreviewBodyHtml(groupKey, productId) {
      if (!groupKey) return ''
      var entry = getMemorialEntry(state, groupKey)
      var pid = resolveMemorialAddonProductId(state, config, groupKey, 'engraving', productId)
      focusMemorialAddonProduct(entry, pid)
      var engraving = entry && entry.addons && entry.addons.engraving
      if (!engraving || !engraving.choiceId || String(engraving.choiceId) === 'no') return ''
      var engLines = normalizeNameplateLines(engraving.lines)
      var fontDef = nameplateFontDef('lavanderia')
      var line1 = String(engraving.text || '').trim()
      var line2 = engLines === 2 ? String(engraving.textLine2 || '').trim() : ''
      if (!line1 && !line2) return ''
      var linesHtml = ''
      if (line1) {
        linesHtml +=
          '<p class="baw-engraving-text-preview__line baw-engraving-text-preview__line--name baw-font-' +
          fontDef.id + '" style="font-family: ' + fontDef.cssFamily + ';">' +
          escapeHtml(line1) +
          '</p>'
      }
      if (line2) {
        linesHtml +=
          '<p class="baw-engraving-text-preview__line baw-font-' + fontDef.id +
          '" style="font-family: ' + fontDef.cssFamily + ';">' +
          escapeHtml(line2) +
          '</p>'
      }
      return (
        '<div class="baw-engraving-text-preview">' +
        '<p class="baw-engraving-text-preview__eyebrow">Engraving</p>' +
        linesHtml +
        '</div>'
      )
    }

    function nameplatePreviewBodyHtml(groupKey, productId) {
      if (!groupKey) return ''
      var catalog = getMemorialCatalog(state, config)
      var pid = resolveMemorialAddonProductId(state, config, groupKey, 'nameplate', productId)
      var nameplate = canonicalNameplateAddon(groupKey, pid)
      if (typeof isCurrentNameplateStep === 'function' && isCurrentNameplateStep(groupKey, pid)) {
        syncNameplateInscriptionFromDom(nameplate)
      }
      var source = memorialAddonSourceForProduct(
        state, config, groupKey, catalog, 'nameplate', pid
      )
      var flags = source && source.flags ? source.flags : null
      if (!nameplate || !nameplate.choiceId || String(nameplate.choiceId) === 'no') return ''
      var colourOptions = buildNameplateColourOptions(flags) || []
      var selectedOpt =
        colourOptions.find(function (o) {
          return String(o.id) === String(nameplate.choiceId)
        }) ||
        (nameplate.colour
          ? colourOptions.find(function (o) { return o.colour === nameplate.colour })
          : null) ||
        null
      var previewImage = nameplatePreviewImageForOption(flags, selectedOpt, config)
      return renderNameplatePreviewHtml(nameplate, previewImage)
    }

    function openCombinedMemorialPreviewModal(el) {
      if (!el) return
      var photoUrl = el.getAttribute('data-baw-photo-preview')
      var photoOrient = el.getAttribute('data-baw-photo-orientation') === 'portrait' ? 'portrait' : 'landscape'
      var photoFrame = el.getAttribute('data-baw-photo-mockup-frame') || ''
      var productUrl = el.getAttribute('data-baw-product-preview')
      var npGroup = el.getAttribute('data-baw-nameplate-preview')
      var npProduct = el.getAttribute('data-baw-nameplate-product')
      var engGroup = el.getAttribute('data-baw-engraving-preview')
      var engProduct = el.getAttribute('data-baw-engraving-product')
      if (productUrl && !photoUrl && !npGroup && !engGroup) {
        openProductImagePreviewModal(productUrl, el.getAttribute('aria-label') || 'Product preview')
        return
      }
      var parts = []
      if (photoUrl && typeof renderPhotoPrintPreview === 'function') {
        parts.push(renderPhotoPrintPreview(photoUrl, photoOrient, photoFrame ? { frameUrl: photoFrame } : {}))
      }
      if (npGroup) {
        var npHtml = nameplatePreviewBodyHtml(npGroup, npProduct)
        if (npHtml) parts.push(npHtml)
      }
      if (engGroup) {
        var engHtml = engravingPreviewBodyHtml(engGroup, engProduct)
        if (engHtml) parts.push(engHtml)
      }
      if (!parts.length) return
      if (parts.length === 1) {
        if (photoUrl && !npGroup && !engGroup) {
          openPhotoPreviewModal(photoUrl, photoOrient, photoFrame)
          return
        }
        if (npGroup && !photoUrl && !engGroup) {
          openNameplatePreviewModal(npGroup, npProduct)
          return
        }
        if (engGroup && !photoUrl && !npGroup) {
          openEngravingTextPreviewModal(engGroup, engProduct)
          return
        }
      }

      closePhotoPreviewModal()
      root.classList.add('has-photo-preview-modal')
      var wrap = document.createElement('div')
      wrap.className = 'baw-photo-preview-modal baw-photo-preview-modal--stack'
      wrap.setAttribute('data-baw-photo-preview-modal', '1')
      wrap.setAttribute('role', 'dialog')
      wrap.setAttribute('aria-modal', 'true')
      wrap.setAttribute('aria-label', 'Memorial preview')
      wrap.innerHTML =
        '<div class="baw-photo-preview-modal-backdrop" data-baw-photo-preview-close tabindex="-1"></div>' +
        '<div class="baw-photo-preview-modal-panel baw-photo-preview-modal-panel--stack">' +
        '<button type="button" class="baw-photo-preview-modal-close" data-baw-photo-preview-close aria-label="Close preview">' +
        '<span aria-hidden="true">&times;</span></button>' +
        '<div class="baw-photo-preview-modal-body baw-photo-preview-modal-body--stack">' +
        parts.join('') +
        '</div></div>'
      root.appendChild(wrap)
      bindPreviewModalChrome(wrap, closePhotoPreviewModal)
      if (typeof wirePhotoPreviewDecodeIn === 'function') wirePhotoPreviewDecodeIn(wrap)
      if (npGroup && typeof fitNameplatePreview === 'function') {
        window.requestAnimationFrame(function () {
          fitNameplatePreview(wrap)
          if (typeof ensureNameplateFontsThenFit === 'function') ensureNameplateFontsThenFit(wrap)
        })
      }
    }

    function bindSummaryPhotoPreviewClicks(rootEl) {
      if (!rootEl || rootEl.getAttribute('data-baw-photo-preview-bound')) return
      rootEl.setAttribute('data-baw-photo-preview-bound', 'true')
      rootEl.addEventListener('click', function (e) {
        var trigger = e.target.closest(
          '[data-baw-photo-preview], [data-baw-product-preview], [data-baw-nameplate-preview], [data-baw-engraving-preview]'
        )
        if (!trigger || !rootEl.contains(trigger)) return
        var kindCount = 0
        if (trigger.getAttribute('data-baw-photo-preview')) kindCount += 1
        if (trigger.getAttribute('data-baw-product-preview')) kindCount += 1
        if (trigger.getAttribute('data-baw-nameplate-preview')) kindCount += 1
        if (trigger.getAttribute('data-baw-engraving-preview')) kindCount += 1
        if (kindCount > 1) {
          e.preventDefault()
          openCombinedMemorialPreviewModal(trigger)
          return
        }
        var productBtn = e.target.closest('[data-baw-product-preview]')
        if (productBtn && rootEl.contains(productBtn)) {
          e.preventDefault()
          var productUrl = productBtn.getAttribute('data-baw-product-preview')
          var productAlt = productBtn.getAttribute('aria-label') || 'Product preview'
          if (productUrl) openProductImagePreviewModal(productUrl, productAlt)
          return
        }
        var nameplateBtn = e.target.closest('[data-baw-nameplate-preview]')
        if (nameplateBtn && rootEl.contains(nameplateBtn)) {
          e.preventDefault()
          var groupKey = nameplateBtn.getAttribute('data-baw-nameplate-preview')
          var productId = nameplateBtn.getAttribute('data-baw-nameplate-product')
          if (groupKey) openNameplatePreviewModal(groupKey, productId)
          return
        }
        var engravingBtn = e.target.closest('[data-baw-engraving-preview]')
        if (engravingBtn && rootEl.contains(engravingBtn)) {
          e.preventDefault()
          var engGroup = engravingBtn.getAttribute('data-baw-engraving-preview')
          var engProduct = engravingBtn.getAttribute('data-baw-engraving-product')
          if (engGroup) openEngravingTextPreviewModal(engGroup, engProduct)
          return
        }
        var btn = e.target.closest('[data-baw-photo-preview]')
        if (!btn || !rootEl.contains(btn)) return
        e.preventDefault()
        var previewUrl = btn.getAttribute('data-baw-photo-preview')
        var previewOrient = btn.getAttribute('data-baw-photo-orientation')
        var previewFrame = btn.getAttribute('data-baw-photo-mockup-frame')
        if (previewUrl) openPhotoPreviewModal(previewUrl, previewOrient, previewFrame)
      })
    }

    function closeStartAgainModal() {
      var modal = root.querySelector('[data-baw-reset-modal]')
      if (modal) modal.parentNode.removeChild(modal)
      root.classList.remove('has-reset-modal')
    }

    function openStartAgainModal() {
      closeStartAgainModal()
      root.classList.add('has-reset-modal')
      var wrap = document.createElement('div')
      wrap.className = 'baw-reset-modal'
      wrap.setAttribute('data-baw-reset-modal', '1')
      wrap.setAttribute('role', 'dialog')
      wrap.setAttribute('aria-modal', 'true')
      wrap.setAttribute('aria-labelledby', 'baw-reset-title')
      wrap.innerHTML =
        '<div class="baw-modal-backdrop baw-reset-modal-backdrop" data-baw-reset-cancel tabindex="-1"></div>' +
        '<div class="baw-reset-modal-card">' +
        '<button type="button" class="baw-reset-modal-close" data-baw-reset-cancel aria-label="Close">' +
        '<span aria-hidden="true">&times;</span></button>' +
        '<h2 class="baw-reset-modal-title" id="baw-reset-title">Start over?</h2>' +
        '<p class="baw-reset-modal-body">This will clear the information and selections in your current booking.</p>' +
        '<div class="baw-reset-modal-actions">' +
        '<button type="button" class="baw-reset-modal-keep" data-baw-reset-cancel>Cancel</button>' +
        '<button type="button" class="baw-reset-modal-confirm" data-baw-reset-confirm>Start again</button>' +
        '</div>' +
        '</div>'
      root.appendChild(wrap)
      var confirmBtn = wrap.querySelector('[data-baw-reset-confirm]')
      var cancelBtns = wrap.querySelectorAll('[data-baw-reset-cancel]')
      function onCancel() { closeStartAgainModal() }
      cancelBtns.forEach(function (btn) { btn.addEventListener('click', onCancel) })
      if (confirmBtn) {
        // Must go through createWizard resetBookingWizard: INSTALL_SRC with(ctx)
        // cannot rebind the closed-over wizard state via bare assignment.
        confirmBtn.addEventListener('click', function () {
          resetBookingWizard()
        })
        try { confirmBtn.focus({ preventScroll: true }) } catch (err) { confirmBtn.focus() }
      }
      wrap.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault()
          onCancel()
        }
      })
    }

    function bindStartAgainControls(rootEl) {
      if (!rootEl || rootEl.getAttribute('data-baw-start-again-bound')) return
      rootEl.setAttribute('data-baw-start-again-bound', 'true')
      rootEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-baw-start-again]')
        if (!btn || !rootEl.contains(btn)) return
        e.preventDefault()
        openStartAgainModal()
      })
    }

    function summaryEditButton(stepId, sectionId) {
      // Always render an Edit-sized slot so section heads stay anchored when the
      // control is inactive on the current step (visibility:hidden — same box).
      if (!stepId) {
        return '<span class="baw-review-edit baw-review-edit--slot" aria-hidden="true"></span>'
      }
      var cur = state.currentStepId
      var reserved = cur === stepId
      // Hide while the family is already viewing a related step in this section
      if (!reserved && sectionId === 'transport' && String(cur).indexOf('transport') === 0) reserved = true
      if (!reserved && sectionId === 'cremation' && String(cur).indexOf('cremation') === 0) reserved = true
      if (
        !reserved &&
        sectionId === 'ashes-return' &&
        (cur === 'return-speed' || cur === 'return-method')
      ) {
        reserved = true
      }
      if (!reserved && sectionId === 'memorials' && String(cur).indexOf('memorial:') === 0) reserved = true
      if (reserved) {
        return (
          '<button type="button" class="baw-review-edit baw-review-edit--reserved" tabindex="-1"' +
          ' aria-hidden="true" disabled>Edit</button>'
        )
      }
      return (
        '<button type="button" class="baw-review-edit" data-baw-summary-edit="' +
        escapeHtml(stepId) +
        '">Edit</button>'
      )
    }

    function summaryPetHtml() {
      // Name (serif) · breed (body) + Edit on one row; weight on Cremation line.
      // Same structure on every step so the rail (and CREMATION below) stay put.
      // Rail: up to 2 first names (“Max & Bella”); full name on review + cart.
      var names = petRailDisplayNames()
      if (!names.length) return ''
      var nameLabel = names.join(' & ')
      var breed = state.pet.breed ? String(state.pet.breed).trim() : ''
      var editBtn = summaryEditButton('pet')
      var titleHtml =
        '<span class="baw-summary-pet-title">' +
        '<span class="baw-summary-pet-name">' + escapeHtml(nameLabel) + '</span>' +
        (breed
          ? '<span class="baw-summary-pet-sep" aria-hidden="true"> · </span>' +
            '<span class="baw-summary-pet-breed">' + escapeHtml(breed) + '</span>'
          : '') +
        '</span>'
      return (
        '<div class="baw-summary-pet">' +
        '<div class="baw-summary-pet-row">' +
        titleHtml +
        editBtn +
        '</div>' +
        '</div>'
      )
    }

    /**
     * Identity block for desktop topbar summary chrome + mobile sheet.
     * Heading + pet (serif name · body breed / Edit row) mount together.
     */

    function summaryIntroHtml(opts) {
      opts = opts || {}
      var petHtml = summaryPetHtml()
      var heading =
        opts.includeHeading === false
          ? ''
          : '<p class="baw-summary-heading">Booking summary</p>'
      if (!heading && !petHtml) return ''
      return '<div class="baw-summary-identity">' + heading + petHtml + '</div>'
    }

    function summaryFooterInnerHtml() {
      return (
        '<span class="baw-summary-quiet-reassure-icon" aria-hidden="true">i</span>' +
        '<span class="baw-summary-quiet-reassure-copy">Nothing is booked until checkout. ' +
        '<button type="button" class="baw-summary-reset" data-baw-start-again>Start over?</button></span>'
      )
    }

    function summaryFooterHtml() {
      return (
        '<p class="baw-summary-quiet-reassure" role="note">' +
        summaryFooterInnerHtml() +
        '</p>'
      )
    }

    function ledgerPriceLabel(item) {
      if (!item || item.isPending || item.isPetHeader || item.hidePrice) return ''
      if (item.included) return 'Included'
      if (item.price) return money(item.price)
      // Free product choices (e.g. Short Goodbye) — show Included so the rail matches the option tiles.
      if (item.variantId != null) return 'Included'
      return ''
    }

    function summaryPreviewIconButton(attrs, ariaLabel) {
      return (
        '<button type="button" class="baw-summary-photo-preview"' +
        attrs +
        ' aria-label="' + escapeHtml(ariaLabel) + '">' +
        '<svg class="baw-summary-photo-preview__icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" d="M2.8 12s3.4-6.5 9.2-6.5S21.2 12 21.2 12s-3.4 6.5-9.2 6.5S2.8 12 2.8 12z"/>' +
        '<circle cx="12" cy="12" r="2.6" fill="none" stroke="currentColor" stroke-width="1.7"/>' +
        '</svg>' +
        '</button>'
      )
    }

    function summaryPhotoPreviewButton(url, orientation, frameUrl) {
      if (!url) return ''
      var orient = orientation === 'portrait' ? 'portrait' : 'landscape'
      var frame = String(frameUrl || '').trim()
      return summaryPreviewIconButton(
        ' data-baw-photo-preview="' + escapeHtml(url) + '"' +
        ' data-baw-photo-orientation="' + orient + '"' +
        (frame ? ' data-baw-photo-mockup-frame="' + escapeHtml(frame) + '"' : ''),
        'View photo'
      )
    }

    function summaryEngravingPreviewButton(groupKey, productId) {
      if (!groupKey) return ''
      var productAttr = productId != null && String(productId) !== ''
        ? ' data-baw-engraving-product="' + escapeHtml(String(productId)) + '"'
        : ''
      return summaryPreviewIconButton(
        ' data-baw-engraving-preview="' + escapeHtml(groupKey) + '"' + productAttr,
        'View engraving'
      )
    }

    /** Number badge + ashes tag around a memorial label (summary / review). */

    function memorialLabelDecorationsHtml(labelHtml) {
      return labelHtml
    }

    function summaryValueWithPreview(item) {
      var label = escapeHtml((item && item.valueLabel) || '')
      label = memorialLabelDecorationsHtml(label, item)
      var previewBtn = ''
      if (item && item.photoPreviewUrl) {
        previewBtn = summaryPhotoPreviewButton(
          item.photoPreviewUrl,
          item.photoOrientation,
          item.photoMockupFrame
        )
      } else if (item && item.nameplatePreviewGroupKey) {
        previewBtn = summaryNameplatePreviewButton(
          item.nameplatePreviewGroupKey,
          item.nameplatePreviewProductId
        )
      } else if (item && item.engravingPreviewGroupKey) {
        previewBtn = summaryEngravingPreviewButton(
          item.engravingPreviewGroupKey,
          item.engravingPreviewProductId
        )
      }
      if (!previewBtn) return label
      return (
        '<span class="baw-summary-photo-line">' +
        '<span class="baw-summary-photo-line__label">' + label + '</span>' +
        previewBtn +
        '</span>'
      )
    }

    function summaryCategorySubheadHtml(label) {
      if (!label) return ''
      return (
        '<div class="baw-summary-category" role="presentation">' +
        escapeHtml(label) +
        '</div>'
      )
    }

    /** Insert quiet category subheads before each memorial group (summary / review). */

    function withMemorialCategorySubheads(lines, renderLineHtml) {
      var html = ''
      var lastKey = null
      ;(lines || []).forEach(function (item) {
        if (
          item &&
          !item.nested &&
          !isPlacementLedgerLine(item) &&
          item.memorialCategoryLabel
        ) {
          var key = item.memorialGroupKey != null ? String(item.memorialGroupKey) : item.memorialCategoryLabel
          if (key !== lastKey) {
            html += summaryCategorySubheadHtml(item.memorialCategoryLabel)
            lastKey = key
          }
        }
        html += renderLineHtml(item)
      })
      return html
    }

    /** Compact ⓘ + status text — same info pattern as quiet-reassure / guidance. */

    function placementStatusNoteHtml(labelHtml) {
      if (!labelHtml) return ''
      return (
        '<span class="baw-placement-status-note">' +
        '<span class="baw-placement-status-note__icon" aria-hidden="true">i</span>' +
        '<span class="baw-placement-status-note__text">' +
        labelHtml +
        '</span>' +
        '</span>'
      )
    }

    function isPlacementLedgerLine(item) {
      return !!(
        item &&
        (item.isPlacement || String(item.id || '').indexOf(':ashes-placement') !== -1)
      )
    }

    function ashesPlacementEditButtonHtml() {
      return (
        '<button type="button" class="baw-review-edit baw-summary-placement-edit"' +
        ' data-baw-summary-edit-ashes-placement' +
        ' aria-label="Change ashes placement">Change</button>'
      )
    }

    function openAshesPlacementEditor() {
      var entry = state.memorials && state.memorials.urn
      if (entry) {
        var Mplace =
          typeof AngelAshesBookingMemorials !== 'undefined' ? AngelAshesBookingMemorials : null
        if (Mplace && Mplace.bindPlacementWeight) Mplace.bindPlacementWeight(entry, state)
        var canEditPlacement = Mplace && Mplace.needsAshesPlacementChoice
          ? Mplace.needsAshesPlacementChoice(entry)
          : Mplace && Mplace.urnRoleVesselCount
            ? Mplace.urnRoleVesselCount(entry) >= 2
            : Mplace && Mplace.fullCapacityVesselCount
              ? Mplace.fullCapacityVesselCount(entry) >= 2
              : (entry.items || []).length >= 2
        if (!canEditPlacement) {
          goTo('memorial:urn')
          return
        }
        entry._ashesPlacementModalOpen = true
        entry._ashesPlacementError = null
      }
      goTo('memorial:urn')
    }

    function summaryCollapsedMetaPreviewButton(meta) {
      var preview = meta && meta.preview
      if (!preview) return ''
      if (preview.kind === 'photo') {
        return summaryPhotoPreviewButton(preview.url, preview.orientation, preview.frameUrl)
      }
      if (preview.kind === 'nameplate') {
        return summaryNameplatePreviewButton(preview.groupKey, preview.productId)
      }
      if (preview.kind === 'engraving') {
        return summaryEngravingPreviewButton(preview.groupKey, preview.productId)
      }
      return ''
    }

    function summaryCollapsedMetaLineHtml(meta) {
      if (!meta) return ''
      var previewBtn = summaryCollapsedMetaPreviewButton(meta)
      var kind = meta.preview && meta.preview.kind
      if (previewBtn && (kind === 'nameplate' || kind === 'engraving')) {
        return (
          '<span class="baw-summary-photo-line baw-summary-photo-line--icon-only">' +
          previewBtn +
          '</span>'
        )
      }
      if (!meta.text) return ''
      var textHtml = '<span class="baw-summary-memorial-meta">' + escapeHtml(meta.text) + '</span>'
      if (!previewBtn) return textHtml
      return (
        '<span class="baw-summary-photo-line">' +
        textHtml +
        previewBtn +
        '</span>'
      )
    }

    function collapsedPhotoMockupPreview(item) {
      var lines = (item && item.metaLines) || []
      var i
      for (i = 0; i < lines.length; i++) {
        var preview = lines[i] && lines[i].preview
        if (preview && preview.kind === 'photo' && preview.url) {
          return preview
        }
      }
      var itemUrl = item && item.photoPreviewUrl ? String(item.photoPreviewUrl).trim() : ''
      var itemFrame = item && item.photoMockupFrame ? String(item.photoMockupFrame).trim() : ''
      if (!itemUrl) return null
      return {
        kind: 'photo',
        url: itemUrl,
        orientation: item && item.photoOrientation === 'landscape' ? 'landscape' : 'portrait',
        frameUrl: itemFrame,
        nativeWide: !!(item && item.photoMockupNativeWide),
        nativeTall: !!(item && item.photoMockupNativeTall),
      }
    }

    function summaryCollapsedMemorialHtml(item) {
      var priceLabel = ledgerPriceLabel(item)
      var photoPreview = collapsedPhotoMockupPreview(item)
      var thumb = ''
      var frameUrl = photoPreview && photoPreview.frameUrl
        ? String(photoPreview.frameUrl).trim()
        : ''
      var photoUrl = photoPreview && photoPreview.url
        ? String(photoPreview.url).trim()
        : ''
      var orient =
        photoPreview && photoPreview.orientation === 'landscape' ? 'landscape' : 'portrait'
      // Live mockup only after a client photo exists. Before that, use the
      // merchandising Card photo (same as the grid). Empty dual-window
      // frames crop to the paw pane at sidebar size.
      if (frameUrl && photoUrl && typeof renderPhotoPrintPreview === 'function') {
        var mockupOpts = {
          frameUrl: frameUrl,
          nativeWide: !!(photoPreview && photoPreview.nativeWide),
          nativeTall: !!(photoPreview && photoPreview.nativeTall),
        }
        if (!mockupOpts.nativeWide && !mockupOpts.nativeTall) {
          // Urn / Photo Tribute artboards are tall; Ink/Clay dual-window are wide.
          if (
            String(item && item.memorialGroupKey || '') === 'urn' ||
            /photo tribute/i.test(String(item && item.valueLabel || ''))
          ) {
            mockupOpts.nativeTall = true
          } else {
            mockupOpts.nativeWide = true
          }
        }
        // Never allow both — tall wins so dual-window inset cannot clip Photo Tribute.
        if (mockupOpts.nativeTall) mockupOpts.nativeWide = false
        thumb =
          '<span class="baw-summary-memorial-thumb baw-summary-memorial-thumb--mockup" aria-hidden="true">' +
          renderPhotoPrintPreview(photoUrl, orient, mockupOpts) +
          '</span>'
      } else if (photoUrl) {
        var summaryThumbW =
          (typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.MEMORIAL_SUMMARY_THUMB_PX) ||
          360
        thumb =
          '<img class="baw-summary-memorial-thumb baw-summary-memorial-thumb--photo" src="' +
          escapeHtml(sizedShopifyImageUrl(photoUrl, summaryThumbW)) +
          '" alt="" width="40" height="40" decoding="async">'
      } else if (item && item.image) {
        var summaryImgW =
          (typeof AngelAshesBookingMemorials !== 'undefined' &&
            AngelAshesBookingMemorials.MEMORIAL_SUMMARY_THUMB_PX) ||
          360
        thumb =
          '<img class="baw-summary-memorial-thumb' +
          (item.personaliseThumb ? ' baw-summary-memorial-thumb--personalise' : '') +
          '" src="' +
          escapeHtml(sizedShopifyImageUrl(item.image, summaryImgW)) +
          '" alt="" width="40" height="40" decoding="async">'
      } else {
        thumb = '<span class="baw-summary-memorial-thumb baw-summary-memorial-thumb--empty" aria-hidden="true"></span>'
      }
      var nestedRows = []
      ;((item && item.metaLines) || []).forEach(function (meta) {
        if (!meta) return
        if (!meta.text && !meta.preview) return
        nestedRows.push(meta)
      })
      function metaPriceLabel(meta) {
        if (!meta || meta.hidePrice) return ''
        if (meta.price) return money(meta.price)
        if (meta.included) return 'Included'
        return ''
      }
      var nestedHtml = nestedRows.map(function (meta) {
        var nestedPrice = metaPriceLabel(meta)
        var nestedPreview = summaryCollapsedMetaPreviewButton(meta)
        var label = meta.text || (meta.preview && meta.preview.kind === 'engraving'
          ? 'Engraving'
          : meta.preview && meta.preview.kind === 'nameplate'
            ? 'Nameplate'
            : '')
        if (!label && !nestedPreview && !nestedPrice) return ''
        return (
          '<div class="baw-summary-memorial-row is-nested">' +
          '<span class="baw-summary-memorial-preview">' + nestedPreview + '</span>' +
          '<span class="baw-summary-memorial-meta">' + escapeHtml(label) + '</span>' +
          (nestedPrice
            ? '<span class="baw-summary-item-price' + (meta.price ? '' : ' is-included') + '">' +
              escapeHtml(nestedPrice) +
              '</span>'
            : '<span class="baw-summary-memorial-price-slot" aria-hidden="true"></span>') +
          '</div>'
        )
      }).join('')
      return (
        '<div class="baw-summary-section-line is-memorial-collapsed">' +
        thumb +
        '<div class="baw-summary-memorial-stack">' +
        '<div class="baw-summary-memorial-row">' +
        '<span class="baw-summary-section-value">' + escapeHtml((item && item.valueLabel) || '') + '</span>' +
        (priceLabel
          ? '<span class="baw-summary-item-price' + (item.price ? '' : ' is-included') + '">' +
            escapeHtml(priceLabel) +
            '</span>'
          : '<span class="baw-summary-memorial-price-slot" aria-hidden="true"></span>') +
        '</div>' +
        nestedHtml +
        '</div>' +
        '</div>'
      )
    }

    function summarySectionLineHtml(item) {
      if (item && item.collapsed) return summaryCollapsedMemorialHtml(item)
      var priceLabel = ledgerPriceLabel(item)
      var valueClass =
        'baw-summary-section-value' +
        (item && item.id === 'transport-vet' ? ' baw-summary-clinic-name' : '')
      var lineMods = ''
      if (item && item.nested) lineMods += ' is-nested'
      var isPlacement = isPlacementLedgerLine(item)
      if (isPlacement) lineMods += ' is-placement'
      var valueHtml = summaryValueWithPreview(item)
      return (
        '<div class="baw-summary-section-line' + lineMods + '">' +
        '<span class="' + valueClass + '">' + valueHtml + '</span>' +
        (isPlacement
          ? (item.showPlacementEdit === false ? '' : ashesPlacementEditButtonHtml())
          : priceLabel
            ? '<span class="baw-summary-item-price' + (item.price ? '' : ' is-included') + '">' +
              escapeHtml(priceLabel) +
              '</span>'
            : '') +
        '</div>'
      )
    }

    function summarySectionHtml(section) {
      if (!section || !section.lines || !section.lines.length) return ''
      var linesHtml = section.showCategorySubheads
        ? withMemorialCategorySubheads(section.lines, summarySectionLineHtml)
        : section.lines.map(summarySectionLineHtml).join('')
      return (
        '<div class="baw-summary-section" data-baw-summary-section="' + escapeHtml(section.id) + '">' +
        '<div class="baw-summary-section-head">' +
        '<span class="baw-summary-section-title">' + escapeHtml(section.title) + '</span>' +
        summaryEditButton(section.editStepId, section.id) +
        '</div>' +
        linesHtml +
        '</div>'
      )
    }

    function bindSummaryEditClicks(rootEl) {
      if (!rootEl || rootEl.getAttribute('data-baw-summary-edit-bound')) return
      rootEl.setAttribute('data-baw-summary-edit-bound', 'true')
      rootEl.addEventListener('click', function (e) {
        var ashesEdit = e.target.closest('[data-baw-summary-edit-ashes-placement]')
        if (ashesEdit && rootEl.contains(ashesEdit) && !ashesEdit.disabled) {
          e.preventDefault()
          openAshesPlacementEditor()
          return
        }
        var btn = e.target.closest('[data-baw-summary-edit]')
        if (!btn || !rootEl.contains(btn) || btn.disabled) return
        if (btn.classList.contains('baw-review-edit--reserved')) return
        e.preventDefault()
        var stepId = btn.getAttribute('data-baw-summary-edit')
        if (stepId) goTo(stepId)
      })
    }

    function renderSummary() {
      var items = buildLedger(state, config)
      var total = ledgerTotal(items)
      var choiceItems = items.filter(function (i) { return !i.isPetHeader })
      var petStripHtml = summaryPetHtml()
      var hasPet = !!petStripHtml
      var sections = buildSummarySections(items, state, config)
      var hasSections = sections.length > 0

      var card = root.querySelector('.baw-summary-card')
      // Desktop topbar rail + mobile sheet: BOOKING SUMMARY heading + pet identity.
      var desktopIntroHtml = summaryIntroHtml({ includeHeading: true })
      var sheetIntroHtml = summaryIntroHtml({ includeHeading: true })
      var sectionsHtml = sections.map(summarySectionHtml).join('')
      var hasContent = !!(hasPet || hasSections)

      if (els.summaryLabel) {
        if (hasPet && total > 0) {
          els.summaryLabel.textContent = 'Booking Total'
          if (els.summaryAmount) {
            els.summaryAmount.textContent = money(total)
            els.summaryAmount.hidden = false
          }
        } else {
          els.summaryLabel.textContent = 'Booking summary'
          if (els.summaryAmount) {
            els.summaryAmount.textContent = ''
            els.summaryAmount.hidden = true
          }
        }
      }

      // Hide the sticky bar until there’s a running total — empty “Your booking”
      // on step 1 takes thumb space and doesn’t help conversion.
      // Review: keep the Total row in the mobile dock (sheet stays collapsed).
      if (els.summaryMobile) {
        var showMobileBar = hasPet && total > 0 && state.currentStepId !== 'review'
        els.summaryMobile.hidden = !showMobileBar
        if ((!showMobileBar || state.currentStepId === 'review') && els.summarySheet) {
          els.summarySheet.classList.remove('is-open')
          if (els.summaryToggle) els.summaryToggle.setAttribute('aria-expanded', 'false')
        }
      }
      if (els.summaryTotalDesktop) els.summaryTotalDesktop.textContent = money(total)

      // Desktop: heading + pet in the topbar summary chrome (above the ledger body).
      if (els.topbarSummary) {
        els.topbarSummary.innerHTML = desktopIntroHtml
        if (desktopIntroHtml) els.topbarSummary.removeAttribute('aria-hidden')
        else els.topbarSummary.setAttribute('aria-hidden', 'true')
      }
      if (els.summaryIntro) {
        els.summaryIntro.innerHTML = ''
        els.summaryIntro.setAttribute('hidden', '')
      }

      // List body: only completed selections from step 2 onwards
      var listHtml = sectionsHtml
      var showSummaryFooter = hasPet && state.currentStepId !== 'review'
      var footerHtml = showSummaryFooter ? summaryFooterHtml() : ''
      // Mobile sheet: identity + lines + Total, then quiet Start-over line
      // (sits just above Previous / Continue). Desktop sidebar order is unchanged.
      var sheetHtml =
        sheetIntroHtml +
        listHtml +
        (choiceItems.length
          ? '<div class="baw-summary-total-row baw-summary-total-row--mobile">' +
            '<span>Total</span><span>' + money(total) + '</span></div>'
          : '') +
        footerHtml
      els.summarySheet.innerHTML = sheetHtml
      els.summaryList.innerHTML = listHtml

      // Desktop sidebar quiet line (steps 1–5 only). Review shows it once above CTA.
      if (els.summaryReassure) {
        els.summaryReassure.hidden = !showSummaryFooter
        if (showSummaryFooter) {
          els.summaryReassure.innerHTML = summaryFooterInnerHtml()
        }
      }

      bindSummaryEditClicks(els.topbarSummary)
      bindSummaryEditClicks(els.summaryList)
      bindSummaryEditClicks(els.summarySheet)
      bindSummaryPhotoPreviewClicks(els.topbarSummary)
      bindSummaryPhotoPreviewClicks(els.summaryList)
      bindSummaryPhotoPreviewClicks(els.summarySheet)
      bindStartAgainControls(els.summaryReassure)
      bindStartAgainControls(els.summarySheet)
      if (typeof wirePhotoPreviewDecodeIn === 'function') {
        if (els.summaryList) wirePhotoPreviewDecodeIn(els.summaryList)
        if (els.summarySheet) wirePhotoPreviewDecodeIn(els.summarySheet)
        // Re-measure after layout so Ink/Clay wide frames contain inside 36×36
        // (and Gold↔Silver artboard aspects stay matched).
        if (typeof resizePhotoMockupsIn === 'function' && typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function () {
            if (els.summaryList) resizePhotoMockupsIn(els.summaryList)
            if (els.summarySheet) resizePhotoMockupsIn(els.summarySheet)
          })
        }
      }

      if (card) {
        card.classList.toggle('is-empty', !hasPet)
        card.classList.toggle('has-pet', hasPet)
        card.classList.toggle('has-items', hasContent)
      }
      var totalRow = card && card.querySelector('.baw-summary-total-row:not(.baw-summary-total-row--mobile)')
      if (totalRow) totalRow.hidden = false
      syncFunnelChromePadding()
    }

    /* ------------------------------ step router ------------------------------- */`
  var INSTALL_EXPORTS = [
    "closePhotoPreviewModal",
    "bindPreviewModalChrome",
    "openEngravingExampleModal",
    "openProductImagePreviewModal",
    "openPhotoPreviewModal",
    "openEngravingTextPreviewModal",
    "openCombinedMemorialPreviewModal",
    "bindSummaryPhotoPreviewClicks",
    "closeStartAgainModal",
    "openStartAgainModal",
    "bindStartAgainControls",
    "summaryEditButton",
    "summaryPetHtml",
    "summaryIntroHtml",
    "summaryFooterInnerHtml",
    "summaryFooterHtml",
    "ledgerPriceLabel",
    "summaryPreviewIconButton",
    "summaryPhotoPreviewButton",
    "summaryEngravingPreviewButton",
    "memorialLabelDecorationsHtml",
    "summaryValueWithPreview",
    "summaryCategorySubheadHtml",
    "withMemorialCategorySubheads",
    "placementStatusNoteHtml",
    "isPlacementLedgerLine",
    "ashesPlacementEditButtonHtml",
    "openAshesPlacementEditor",
    "summaryCollapsedMetaLineHtml",
    "summaryCollapsedMemorialHtml",
    "summarySectionLineHtml",
    "summarySectionHtml",
    "bindSummaryEditClicks",
    "renderSummary"
  ]

  function install(ctx) {
    var api = {}
    // Sloppy-mode runner: with (ctx) resolves free identifiers to the live
    // wizard context (state, els, render, helpers). Function declarations in
    // INSTALL_SRC become install-locals and are exported onto api.
    var body = 'with (ctx) {\n' + INSTALL_SRC + '\n'
    for (var i = 0; i < INSTALL_EXPORTS.length; i++) {
      var name = INSTALL_EXPORTS[i]
      body += 'api[' + JSON.stringify(name) + '] = ' + name + ';\n'
    }
    body += '}'
    var runner = new Function('ctx', 'api', body)
    runner(ctx, api)
    return api
  }

  global.AngelAshesBookingCart = {
    create: create,
    install: install,
  }
})(typeof window !== 'undefined' ? window : this)
